import React from 'react';
import ReactDOM from 'react-dom';
import Dict from 'dict-lib';
import MicrolinkCard from '@microlink/react';
import {arrayMove, SortableContainer, SortableElement, SortableHandle} from 'react-sortable-hoc';
import ReactTooltip from 'react-tooltip';
import {LexemeNavigator, SCCheckbox, SCCombo, SCRadiobutton, SCTree} from '../../components';
import {AsyncTypeahead, Typeahead} from 'react-bootstrap-typeahead';
import tinymce from 'tinymce';
import 'tinymce/themes/modern';
import {Editor} from '@tinymce/tinymce-react';
import '../../tinymce/plugin.min';
import {NodeOperations, TreeDOMHelper, TreeNodeHelper, TreeUtilities} from './TreeHelper';
import {
    Button,
    Carousel,
    CarouselItem,
    Col,
    ControlLabel,
    FormControl,
    FormGroup,
    HelpBlock,
    Glyphicon,
    Image,
    InputGroup,
    Modal,
    Row,
    Alert
} from 'react-bootstrap';
import Dropzone from 'react-dropzone';
import {Notifications} from './../../../utilities/DictUtilities';
import {ContextMenu, ContextMenuProvider, Item, Separator, Submenu} from 'react-contexify';
import {Page} from 'react-pdf';
import {Document} from 'react-pdf/dist/entry.webpack';
import GoogleDocsViewer from 'react-google-docs-viewer';

import 'react-contexify/dist/ReactContexify.min.css';
import 'draggable-react-tree-component/lib/styles.css';

import FontAwesome from 'react-fontawesome';
import {AdministrationUtilities} from "../../../administration/AdministrationHelper";
import {LexemeEditingLevel, LexemeUtilities} from "../../../lexeme/page/editor/LexemeHelper";
import stylesSCTree from './../SCTree.module.css';
import stylesSorter from './../../../_css/sorter.module.css';
import './../SCTree.css';
import {userService} from "../../../_redux/authentication/services/user.services";
import BUtils from "../../../utilities/BaseUtilities";
import {TreeContext} from "../../../corpora/TreeContext";
import {TreeMissingWordsFinder} from "./TreeMissingWordsFinder";
import {TreeModalStrippingWords} from "./TreeModalStrippingWords";


export class TreeItemMenu extends React.Component {

    constructor(props) {
        super(props);

        this.isLogged = userService.isLogged();
        this.isAdministrator = userService.isAdministrator();
        this.role = props.roleProps.role;
        this.isInserter = props.roleProps.isInserter;
        this.isModifier = props.roleProps.isModifier;
        this.isModifierOrAdministrator = this.isModifier || this.isAdministrator;

        this.state = {
            composedCollections: this.props.composedCollections,
            interfaceLang: '',
            subMenuWillOverflow: false,
            importStructure: {},
            showDocModal: false,
            showContextMenu: false,
            countChildren: 'calculating...'
        };

        this._handleRemoveItem = this._handleRemoveItem.bind(this);
        this._importData = this._importData.bind(this);
        this._acceptImportData = this._acceptImportData.bind(this);

        this.firstClick = 0;
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        //var isClick = !nextState.nextPrevFound && typeof nextState.data !== 'undefined' && nextState.data.length > 0;
        return this.props.item.key === this.props.lastUpdate || nextState.showContextMenu || (this.state.countChildren !== nextState.countChildren) /*|| (this.props.item.code === 'FOLDER' && this.props.item.isHiddenBranch)*/;
    }

    /*componentDidUpdate(prevProps, prevState, snapshot) {

    }*/

    componentWillMount() {
        this._resetImportStructure();
    }

    componentWillReceiveProps(nextProps) {
        this.setState({interfaceLang: nextProps.interfaceLang})
    }

    componentDidMount() {
        if (this.props.item.key === this.props.lastRenderKey /*parentKey === this.props.expandedKeys[this.props.expandedKeys.length - 1]*/) {
            var spinnerElement = document.getElementById('loading-key-spin-' + NodeOperations.retrieveParentKey(this.props.item));
            if (spinnerElement !== null)
                spinnerElement.style.display = 'none';
        }

        this._countChildren();

        /*var elMinorButtonContainer = document.getElementById('node-page');//document.querySelectorAll('.' + stylesSCTree['tree-docs-viewer-item__buttons']);
        var elButtons = elMinorButtonContainer.getElementsByTagName('button');
        for (var el of elButtons) {
            el.style.backgroundColor = Dict.getGlobalProperty('TREE_MINOR_SKIN');
        }*/
    }


    _handleOpenEditItem(event, item) {
        this._handleOpenContextMenuItem(event, TreeNodeHelper.treeNodeOperations.EDIT, item, undefined, TreeNodeHelper.isBasicItem(item.code));
        TreeDOMHelper.trySetEditItemSkin(1);
        //const inputId = 'input-add-node';
        //document.getElementById(inputId).value = item.title;
    }

    _handleDocsAnalyze(event, item) {
        ReactDOM.render(<TreeMissingWordsFinder show={true} parentKey={item.key} projectName={this.props.projectName}
                                                callBackOpenItem={(item) => this.props.callbackOpenItem(item)}
                                                parentName={item.title}/>, document.getElementById("dict-modal-container"));
        document.getElementsByTagName("body")[0].click();
    }

    _handleOpenSortItems(event, children, isAlphabetic) {
        var ele = TreeDOMHelper.resetNodePageContainer(event, "node-operations-container");
        var div = '';

        if (children.length > 1) {
            if (typeof isAlphabetic !== 'undefined' && isAlphabetic) {
                div = <div id="div-sort-node-container">
                    <span>{Dict.t('ASK_TREE_CHILDREN_ALPHABETIC_ORDER')}</span>
                    <Button
                        onClick={() => {
                            var sortedChildren = BUtils.sortByKey(children, 'title');
                            var child = sortedChildren[0];
                            this.props.callbackSort(sortedChildren, TreeNodeHelper.isRootItem(child));
                        }
                        }
                    >{Dict.t('YES')}</Button>
                    <Button onClick={() => {
                        TreeDOMHelper.hideNodePageContainer();
                    }}>{Dict.t('NO')}</Button>
                </div>;
            } else {
                var itemList = children.map((child, index) =>
                    <div key={"key-tree-item-sortable-" + index}>
                        {child.title}
                    </div>
                );

                const DragHandle = SortableHandle(() => <div className="items-sortable-handle sortable-handle">
                    <Glyphicon glyph="sort"/>
                </div>);

                const SortableItem = SortableElement(({value}) => {
                    return (
                        <div
                            className={BUtils.joinClasses(stylesSorter['items-sortable-item'], stylesSorter['sortable-item'])}>
                            <DragHandle/>
                            {value}
                        </div>
                    );
                });

                const SortableList = SortableContainer(({items}) => {
                    return (
                        <div className={"div-sortable-container sortable-type-" + this.props.type}>
                            {items.map((value, index) => (
                                <SortableItem key={'sortable-item-' + index} index={index} value={value}/>
                            ))}
                        </div>
                    );
                });

                var sortableItemList = <SortableList key={"key-lex-items-sortable"}
                                                     helperClass={"sortableHelper"} pressDelay={0} lockAxis={"y"}
                                                     useDragHandle={false}
                                                     items={itemList}
                                                     onSortStart={(obj) => {
                                                     }}
                                                     onSortEnd={(obj) => {
                                                         var sortedChildren = arrayMove(children, obj.oldIndex, obj.newIndex);
                                                         var child = sortedChildren[0];
                                                         this.props.callbackSort(sortedChildren, TreeNodeHelper.isRootItem(child));
                                                         this._handleOpenSortItems(event, sortedChildren);
                                                     }}/>;

                div = <div id="div-sort-node-container">{sortableItemList}</div>;
            }
        } else {
            div = <div id="div-sort-node-container">{Dict.t('NO_SORT_COLLECTION_FOUND')}</div>;
        }

        ReactDOM.render(div, ele);
    }

    _handleShowHideItem(event, item) {
        var hiddenField = item.code === 'FOLDER' ? 'hiddenBranch' : 'hidden';
        this.props.callbackShowHideItem(typeof item[hiddenField] === 'undefined' || !item[hiddenField]);
    }

    _handleCutItems(item, cutChildren) {
        this.props.callbackCut(item, cutChildren);
    }

    _handleCopyItems(item, copyChildren) {
        this.props.callbackCopy(item, copyChildren);
    }

    _handlePasteItem(item) {
        this.props.callbackPaste(item);
    }

    _resetCut() {
        this.props.callbackResetCut();
    }

    _handleOpenContextMenuItem(event, operation, item, treeObject, isBasicItem) {
        TreeDOMHelper.resetItemSelection();

        const expander = event.target.parentElement.parentElement.previousSibling;

        TreeDOMHelper.hideNodePageContainer();
        var ele = TreeDOMHelper.resetNodePageContainer(event, "node-operations-container");

        ReactDOM.unmountComponentAtNode(ele);

        var retrieveItem = new Promise((resolve) => {
            if (operation === TreeNodeHelper.treeNodeOperations.ADD) {
                return resolve('');
            } else if (item.data === '' || typeof item.data === 'undefined' || item.data === []) {
                return resolve(Dict.call('/tree/getItemDataByKey/' + this.props.projectName + '/' + item.key + '/'));
            } else {
                return resolve(item.data);
            }
        });


        retrieveItem.then((data) => {
            item.data = data;
            this.setState({data}, () => {
                ReactDOM.render(<TreeNodeEditor item={item} operation={operation} treeObject={treeObject}
                                                isBasicItem={isBasicItem}
                                                {...this.props}
                                                isViewer={false}
                                                callbackParent={(returnItem, operation) => {
                                                    this.props.callbackSave(returnItem, operation, expander, operation === 'add' ? event.target.parentElement : null);
                                                }}/>, ele, function () {

                    if (operation === TreeNodeHelper.treeNodeOperations.ADD) {
                        setTimeout(function () {
                            TreeDOMHelper.resetNodeEditorPosition(ele);
                        }, 0);
                    } else
                        TreeDOMHelper.resetNodeEditorPosition(ele);
                });
            })
        })
    }

    _handleOpenImportItem(event, operation, item, treeObject, isBasicItem) {
        TreeDOMHelper.resetItemSelection();


        const expander = event.target.parentElement.parentElement.previousSibling;


        TreeDOMHelper.hideNodePageContainer();
        var ele = TreeDOMHelper.resetNodePageContainer(event, "node-import-container");

        this._setImportStructure(item, treeObject);

        var allMultimediaMime = "audio/*, audio/mpeg, image/jpeg,image/png,image/gif, video/mp4, video/mpeg, video/quicktime, video/mpg, application/pdf, .doc, .docx";

        ReactDOM.render(<div>
            <div id={"import-tree-object-log"} className={stylesSCTree['node-import-log']}>
                <Row id={"import-tree-object-log-title"}
                     className={stylesSCTree['node-import-log__title']}>{Dict.t('IMPORT_LOG')}</Row>
                <Row id={"import-tree-object-log-contents"} className={stylesSCTree['node-import-log__contents']}/>
                <Row id={"import-tree-object-log-footer"} className={stylesSCTree['node-import-log__footer']}><span
                    id={'info-node-import-log-footer'}
                    className={stylesSCTree['info-node-import-log-footer']}>{Dict.t('IMPORT_DATA_HAS_RESOURCES')}</span>
                    <Button id={"bt-import-tree-object-log-footer"} bsStyle={'primary'}
                            onClick={() => this._acceptImportData(expander)}>{Dict.t('ACCEPT_IMPORT_DATA')}</Button>
                </Row>
            </div>
            <div id={"import-tree-multimedia-dropzone"}
                 className={BUtils.joinClasses(stylesSCTree['node-import-log'], stylesSCTree['node-import-resources'])}>
                <Row id={"import-tree-object-import-resource-title"}
                     className={stylesSCTree['node-import__tree-object-header-info']}>{Dict.t('INSERT_MULTIMEDIA_RESOURCE')}</Row>
                <Row className={stylesSCTree['node-import-log__dropzone']}>
                    <Dropzone
                        accept={allMultimediaMime}
                        acceptClassName="accept-drop-zone"
                        ref={(node) => {
                            this.dropzoneImportResourceElement = node;
                        }}
                        inputProps={{required: treeObject}}
                        className={BUtils.joinClasses(stylesSCTree['node-import-container__dropzone-multimedia-resource'], 'area-dropzone')}
                        onDropAccepted={(acceptedFiles) => {
                            TreeUtilities.addImportMultimediaResources(this.props.projectName, acceptedFiles, function (fileList) {

                                var contents = fileList.map(file => {
                                    return '<div>' + file + '</div>';
                                });

                                document.getElementById('import-tree-object-import-resource-contents').innerHTML = contents.join('');
                                this._prepareImport();
                            }.bind(this));

                        }}
                        onDropRejected={(acceptedFiles) => {
                            Notifications.showErrorModalMessage('DROPPED_FILE_NOT_ACCEPTED', 2000);
                        }}
                    >
                        <p>{Dict.t('INSERT_MULTIMEDIA_RESOURCE_HERE')}</p>
                        <p>{allMultimediaMime}</p>
                    </Dropzone>
                </Row>
                <Row id={"import-tree-object-import-resource-contents"}
                     className={BUtils.joinClasses(stylesSCTree['node-import-log__contents'], stylesSCTree['node-import-resource__contents'])}/>
                <Row id={"import-tree-object-import-resource-footer"}
                     className={stylesSCTree['node-import-log__footer']}>
                    <Button id={"bt-import-tree-object-import-resource-footer"} bsStyle={'primary'}
                            onClick={() => {
                                this._emptyResourceDropZone();
                                this._prepareImport();
                            }}>{Dict.t('EMPTY')}</Button>
                    <Button id={"bt-import-tree-object-close-import-resource-footer"} bsStyle={'primary'}
                            onClick={() => {
                                this._closeResourceDropZone();
                                this._prepareImport();
                            }}>{Dict.t('BT_OK')}</Button>
                </Row>
            </div>
            <Row id={"import-tree-object-header-info"}
                 className={BUtils.joinClasses(stylesSCTree['node-import__tree-object-header-info'], stylesSCTree['tree-import-info'], 'tree-import-info-headerfooter')}>{treeObject.code} - {Dict.t('NODE_IMPORT_ON')}: {item.title}</Row>
            <Dropzone accept={'.csv'}
                      acceptClassName="accept-drop-zone"
                      ref={(node) => {
                          this.dropzoneImportElement = node;
                      }}
                      inputProps={{required: treeObject}}
                      className={BUtils.joinClasses(stylesSCTree['node-import-container__dropzone-element'], 'area-dropzone')}
                      onDropAccepted={(acceptedFiles) => {
                          document.getElementById('import-title-missing-info').innerHTML = '';
                          document.getElementById('bt-import-footer').style.visibility = 'hidden';
                          this._resetMultimediaResources();

                          BUtils.convertHeadedCsvToJson(acceptedFiles[0], function (result) {
                              var importStructure = this.state.importStructure;
                              importStructure.items = result;
                              this.setState({importStructure}, function () {
                                  this._prepareImport();
                              }.bind(this));
                          }.bind(this));
                      }}
                      onDropRejected={function () {
                          Notifications.showErrorModalMessage('DROPPED_FILE_NOT_ACCEPTED', 3000);
                      }}>
                <p>{'.csv'}</p>
            </Dropzone>
            <Row id={"import-tree-object-fields-info"} className={stylesSCTree['node-import__tree-import-info']}/>
            <Row id={"import-csv-item-fields-info"} className={stylesSCTree['node-import__tree-import-info']}/>
            <Row id={"import-matching-info"} className={stylesSCTree['node-import__tree-import-info']}/>
            <Row id={"import-title-missing-info"} className={stylesSCTree['node-import__tree-import-info']}/>
            <Row id={"import-footer"}
                 className={BUtils.joinClasses(stylesSCTree['node-import__tree-import-info'], 'tree-import-info-headerfooter')}>
                <Button id={"bt-import-footer"} bsStyle={'primary'}
                        onClick={() => this._importData()}>{Dict.t('IMPORT_LOG')}</Button>
                <Button id={"bt-import-multimedia-footer"} bsStyle={'primary'}
                        onClick={() => this._openImportMultimediaResourceDropzone()}>{Dict.t('IMPORT_MULTIMEDIA_RESOURCE')}</Button>
            </Row>
        </div>, ele, function () {
            //var reactTree = document.getElementsByClassName('react-tree')[0];
            /*if ((parseFloat(ele.offsetHeight) + parseFloat(ele.style.top)) > reactTree.offsetHeight) {
                document.getElementById(ele.id).style.top = 150 + "px";
                document.getElementById('tree-object-element-container').style.maxHeight = (document.getElementsByClassName('react-tree')[0].offsetHeight - 200) + "px";
            }*/
        });
    }

    _convertCsvToJson(file, callback) {
        var csvSeparator = '\t';
        var reader = new FileReader();
        reader.onload = function (event) {
            var lines = event.target.result.split("\n");

            var result = [];

            var headers = lines[0].split(csvSeparator);
            var cleanHeaders = [];

            for (var k = headers.length - 1; k >= 0; k--) {
                if (headers[k].length > 0 && headers[k] !== '\r') {
                    var cleanHeadersTmp = headers.slice(0, k);
                    cleanHeadersTmp.forEach(header => {
                        if (header.trim().length > 0) {
                            cleanHeaders.push(header);
                        } else {
                            cleanHeaders.push('[' + Dict.t('EMPTY_FIELD').toUpperCase() + ']');
                        }
                    });
                    break;
                }
            }

            for (var i = 1; i < lines.length; i++) {
                if (lines[i].trim().length > 0) {
                    var obj = {};
                    var currentline = lines[i].split(csvSeparator);

                    for (var j = 0; j < cleanHeaders.length; j++) {
                        obj[cleanHeaders[j]] = currentline[j];
                    }

                    result.push(obj);
                }
            }

            callback(result);
        };
        reader.readAsText(file, 'utf-8');
    }

    _resetImportStructure() {
        this._setImportStructure();
    }

    _setImportStructure(node, treeObject, items, info, prefix, listFiles) {
        node = typeof node === 'undefined' ? {} : node;
        treeObject = typeof treeObject === 'undefined' ? {} : treeObject;
        items = typeof items === 'undefined' ? [] : items;
        info = typeof info === 'undefined' ? this._getResetImportStructureInfos() : info;
        prefix = typeof prefix === 'undefined' ? '' : prefix;
        listFiles = typeof listFiles === 'undefined' ? [] : listFiles;

        var importStructure = {node, treeObject, items, info, prefix, listFiles};
        this.setState({importStructure});
    }

    _getResetImportStructureInfos() {
        document.querySelectorAll("." + stylesSCTree['node-import__tree-import-info']).forEach(function (element) {
            element.classList.remove(stylesSCTree['node-import__tree-import-info--active']);
        });

        return {
            treeObjectFields: '',
            csvItemFields: '',
            matchingFields: '',
            log: {dataNotAccepted: []},
            listFiles: [],
            importItems: []
        };
    }

    _prepareImport() {

        var importStructure = this.state.importStructure;

        const title = Dict.t('TITLE');
        importStructure.info = this._getResetImportStructureInfos();
        importStructure.info.csvItemFields = Object.keys(importStructure.items[0]);
        var hasTitle = Object.keys(importStructure.items[0])[0].toLowerCase() === title.toLowerCase();
        var treeObjectFieldsInfo;

        var label = '';
        if (importStructure.treeObject.isBasic) {
            label = Dict.t(importStructure.treeObject.element.label);
            importStructure.info.treeObjectFields = [label];
            treeObjectFieldsInfo = "<u>" + label + "</u>";
            importStructure.info.matchingFields = Object.keys(importStructure.items[0]).indexOf(label) > -1 ? label : [];
        } else {
            label = importStructure.treeObject.code;
            importStructure.info.treeObjectFields = importStructure.treeObject.basicItems.map(item => item.i18nLabels.it);
            treeObjectFieldsInfo = importStructure.info.treeObjectFields.map(item => "<u>" + item + "</u>").join(", ");

            importStructure.info.matchingFields = importStructure.treeObject.basicItems.map(item => item.i18nLabels.it).filter(function (n) {
                return Object.keys(importStructure.items[0]).indexOf(n) > -1;
            });
        }

        if (hasTitle) {
            importStructure.info.csvItemFields = Object.keys(importStructure.items[0]).slice(1, Object.keys(importStructure.items[0]).length);
            document.getElementById('bt-import-footer').style.visibility = 'visible';
            importStructure.info.hasTitle = true;
        } else {
            document.getElementById('import-title-missing-info').innerHTML = '<div><span>' + Dict.t('WARNING_IMPORT_COLUMN_TITLE_MISSING') + '</span><input id="import-title-missing-info-input-prefix" onkeyup="document.getElementById(\'bt-import-footer\').style.visibility = (this.value.length > 0 ? \'visible\' : \'hidden\');" type="text" value="" /></div>';
            importStructure.info.hasTitle = false;
        }

        var csvItemFieldsInfo = importStructure.info.csvItemFields.map(item => "<u>" + item + "</u>").join(", ");
        var matchingInfo = importStructure.info.matchingFields.length > 0 ? importStructure.info.matchingFields.map(item => "<u>" + item + "</u>").join(", ") : Dict.t('MATCHING_NOT_FOUND');

        document.getElementById('import-tree-object-fields-info').innerHTML = '<strong>' + Dict.t('ELEMENT_FIELDS') + ' ' + label + '</strong>: ' + treeObjectFieldsInfo;
        document.getElementById('import-csv-item-fields-info').innerHTML = '<strong>' + Dict.t('CSV_FIELDS') + '</strong>: ' + csvItemFieldsInfo;
        document.getElementById('import-matching-info').innerHTML = '<strong>' + Dict.t('MATCHING_FIELDS') + '</strong>: ' + matchingInfo;

        document.querySelectorAll("." + stylesSCTree['node-import__tree-import-info']).forEach(function (element) {
            element.classList.add(stylesSCTree['node-import__tree-import-info--active']);
        });

        Dict.call('/tree/listImportResourceFiles/').then(result => {
            if (result.listFiles.length > 0) {
                importStructure.info.listFiles = result.listFiles.map(function (file, index) {
                    var extension = BUtils.extractFileExtension(file.filename);

                    var type;
                    try {
                        type = BUtils.getFileType(file.filename);
                    } catch (e) {
                        type = 'NOT_FOUND';
                        Notifications.showWarningModalMessage('ignore:' + e, 2000);
                    }

                    return {
                        filename: BUtils.extractFilename(file.filename.substring(0, file.filename.length - extension.length - 1)),
                        extension,
                        type,
                        valid: false
                    };
                });

                this.setState({importStructure});

                document.getElementById('info-node-import-log-footer').style.display = 'inline';
            } else
                document.getElementById('info-node-import-log-footer').style.display = 'none';
        });
    }

    _importData() {
        var importStructure = this.state.importStructure;
        var prefix = importStructure.info.hasTitle ? '' : document.getElementById('import-title-missing-info-input-prefix').value;
        importStructure.info.log.dataNotAccepted = [];
        importStructure.importItems = [];


        var indexItem = 0;
        importStructure.items.map((item, indexItem) => {
            var propAsArrays = Object.keys(item);
            var title = importStructure.info.hasTitle && item[propAsArrays[0]].trim().length > 0 ? item[propAsArrays[0]] : prefix + "_" + new Date().getTime() + "_" + indexItem;
            title = title.trim();
            var data = [];

            var asArray = Object.keys(item);
            var undFieldsLength = asArray.filter(field => {
                return typeof item[field] === 'undefined' || item[field] === '' || item[field] === '\r';
            }).length;

            if (parseInt(100 * undFieldsLength / asArray.length) > 85) {
                this._addImportdataNotAcceptedLog(indexItem, item, Dict.t('TREE_IMPORT_SUSPECT_ITEM'), title);
            } else {

                importStructure.treeObject.basicItems.map((basicItem) => {
                    var element = {
                        label: basicItem.i18nLabels[this.props.interfaceLang],
                        type: basicItem.item.element.type,
                        code: basicItem.item.code,
                        value: ''
                    };

                    if (element.type === 'autocomplete') {
                        if (element.code === 'CUSTOM_DATA_COLLECTION') {
                            element.items = basicItem.item.element.items;
                        } else if (element.code === 'PREFILLED_DATA_COLLECTION') {
                            element.collectionId = basicItem.item.element.collectionId;
                            element.items = [];
                            var composedCollections = this.state.composedCollections;
                            var collection = composedCollections.find((compItem) => {
                                return compItem.id === element.collectionId;
                            });
                            if (typeof collection !== 'undefined') {
                                element.items = JSON.parse(JSON.stringify(collection.items));
                            }
                        } else {
                            element.items = [];
                        }
                    }

                    var titolo = Dict.t('TITLE');
                    titolo = /*titolo.toLowerCase().trim(); // */ (titolo.charAt(0).toUpperCase() + titolo.substr(1)).trim();

                    importStructure.info.matchingFields.forEach(function (matchingField) {
                        var itemMatching = item[matchingField];
                        const isItemDefined = typeof itemMatching !== 'undefined';
                        const labelToCompare = element.label;

                        if (labelToCompare === matchingField) {
                            if (element.type === "datepicker") {
                                var date = isItemDefined ? TreeUtilities.getDateByValue(itemMatching.trim()) : '';
                                if (element.value !== "" && date.length === 0) {
                                    element.value = "";
                                    this._addImportdataNotAcceptedLog(indexItem, item, Dict.t('TREE_IMPORT_NOT_VALID_DATE'), element.label + ' ' + '[gg-mm-aaaa]');
                                } else {
                                    element.value = date.date;
                                    element.choosenMode = date.choosenMode;
                                }
                            } else if (element.type === 'autocomplete') {
                                var label = matchingField;//item[matchingField];
                                var autoCompleteItem = TreeNodeHelper.getAutoCompleteItemByLabel(element.items, item[label], false);
                                element.itemIdSelected = typeof autoCompleteItem === 'undefined' ? undefined : autoCompleteItem.id;
                                if (item[label] !== "" && typeof element.itemIdSelected === 'undefined') {
                                    this._addImportdataNotAcceptedLog(indexItem, item, Dict.t('TREE_IMPORT_AUTOCOMPLETE_LOG_ERROR'), element.label);
                                }
                            } else if (element.type === 'dropzone') {
                                var value = [];

                                var itemMatchingFiles = itemMatching.split(';');

                                itemMatchingFiles.forEach((itemMatchingFile, indexItemMatchingFile) => {
                                    var resourceFile = importStructure.info.listFiles.find((file) => {
                                        return file.filename + "." + file.extension === itemMatchingFile;
                                    });

                                    var resourceFound = typeof resourceFile !== 'undefined';

                                    /*var resourceFound = importStructure.info.listFiles.length > 0 && importStructure.info.listFiles.some((file => {
                                        file.valid = true;
                                        file.title = file.filename; //LEGACY item[titolo];
                                        value.push({filename: file.filename, extension: file.extension});
                                        return true;

                                    }));*/

                                    if (resourceFound) {

                                        resourceFile.valid = true;
                                        resourceFile.title = item[titolo.toLowerCase()];//item.title; //LEGACY item[titolo];
                                        value.push({
                                            filename: resourceFile.filename,
                                            extension: resourceFile.extension
                                        });
                                        element.value = value;
                                    } else {
                                        if (indexItemMatchingFile > 0)
                                            indexItem++;
                                        var msg = typeof item[titolo] == 'undefined' ? Dict.t('TREE_IMPORT_RESOURCE_TITLE_NOT_MACHING') : Dict.t('TREE_IMPORT_RESOURCE_NOT_FOUND');

                                        this._addImportdataNotAcceptedLog(indexItem, item, msg, element.label + ':' + itemMatchingFile.trim());
                                    }
                                });
                            } else if (element.type === 'pathbrowser') {
                                var path = isItemDefined ? itemMatching.trim() : '';
                                if (path.length > 0) {
                                    var encodedFolderPath = LexemeUtilities.encodeUrl(AdministrationUtilities.encodeOSPath(path));
                                    element.value = {path, showContents: false, isDirectory: false};
                                    Dict.call('/tree/checkIsDirectory/' + encodedFolderPath + '/').then(result => {
                                        element.value = {path, showContents: false, isDirectory: result.isDirectory};
                                    }).catch(function (e) {
                                        console.log(e); // "oh, no!"
                                    });
                                } else {
                                    this._addImportdataNotAcceptedLog(indexItem, item, Dict.t('TREE_IMPORT_CHECK_PATH_LOG_ERROR'), element.label);
                                }
                            } else if (element.type === 'alignmentDocs') {
                                const prefix = Dict.getGlobalProperty('ALIGNMENT_DICTIONARY_SERVICE_PREFIX') + (parseFloat(this.props.autoincrement) + parseFloat(indexItem) + 1) + '_';
                                const itemValues = itemMatching.split('|');
                                if (typeof itemValues[1] === 'undefined')
                                    console.log();
                                const langs = itemValues[1].split('_');
                                const lang1 = langs[0];
                                const lang2 = langs[1];
                                const file1 = prefix + itemValues[0].replace('.docx', '') + '_' + lang1 + '.docx';
                                const file2 = prefix + itemValues[0].replace('.docx', '') + '_' + lang2 + '.docx';
                                element.value = {
                                    lang1,
                                    lang2,
                                    file1,
                                    file2,
                                    originalStatus: 'to_store',
                                    status: 'to_store'
                                };
                            } else {
                                element.value = isItemDefined ? itemMatching.trim() : '';
                            }
                        }
                    }.bind(this));

                    data.push(element);
                });

                var parent = importStructure.node;

                var newItem = NodeOperations.createNewItem(parent, title, importStructure.treeObject.code, data);
                importStructure.importItems.push(newItem);

                this.setState({importStructure});
                indexItem++;
            }
        });

        ReactDOM.render(
            <div className={stylesSCTree['node-import-log-container']}
                 dangerouslySetInnerHTML={{__html: importStructure.info.log.dataNotAccepted.join('')}}/>, document.getElementById('import-tree-object-log-contents'), function () {
                document.getElementById('import-tree-multimedia-dropzone').style.display = 'none';
                document.getElementById("import-tree-object-log").style.display = 'block';
            });
    }

    _openImportMultimediaResourceDropzone() {
        var display = document.getElementById('import-tree-multimedia-dropzone').style.display;
        if (display === 'none' || display === '') {
            //TreeUtilities.emptyImportMultimediaResources();
            document.getElementById("import-tree-object-log").style.display = 'none';
            document.getElementById('import-tree-multimedia-dropzone').style.display = 'block';
            /*document.getElementById('import-tree-object-import-resource-contents').innerHTML = '';*/
            document.getElementById('bt-import-footer').disabled = true;
            document.getElementById('bt-import-multimedia-footer').disabled = true;
        }
    }

    _resetWrongColumns() {

    }

    _resetMultimediaResources() {
        /*TreeUtilities.emptyImportMultimediaResources();
        document.getElementById('import-tree-object-import-resource-contents').innerHTML = '';
        this._closeResourceDropZone();*/
        this._closeResourceDropZone();
        this._emptyResourceDropZone();
        document.getElementById("import-tree-object-log").style.display = 'none';
    }

    _closeResourceDropZone() {
        document.getElementById('import-tree-multimedia-dropzone').style.display = 'none';
        document.getElementById('bt-import-footer').disabled = false;
        document.getElementById('bt-import-multimedia-footer').disabled = false;
    }

    _emptyResourceDropZone() {
        TreeUtilities.emptyImportMultimediaResources();
        document.getElementById('import-tree-object-import-resource-contents').innerHTML = '';
    }

    _addImportdataNotAcceptedLog(indexItem, item, msg, contents) {
        var importStructure = this.state.importStructure;
        var titolo = Dict.t('TITLE');
        titolo = (titolo.charAt(0).toUpperCase() + titolo.substr(1)).toLowerCase();
        var itemTitle = (importStructure.info.hasTitle ? item[titolo] : '');
        var rightArrow = '&xrArr;';
        var open = msg === Dict.t('TREE_IMPORT_SUSPECT_ITEM') ? '<div style="color:red" >' : '<div>';

        var element = open + (indexItem + 2) + '- ' + '<strong> ' + itemTitle + ' </strong> - <strong> ' + contents + ' </strong>' + rightArrow + ' ' + msg + ' </div>';

        importStructure.info.log.dataNotAccepted.push(element);
    }

    _acceptImportData(expander) {
        var validFiles = this.state.importStructure.info.listFiles.filter(file => {
            return file.valid;
        });

        const prefix = Dict.getGlobalProperty('ALIGNMENT_DICTIONARY_SERVICE_PREFIX')
        const alignmentPosition = this._retrieveAlignmentPosition(this.state.importStructure.importItems[0]);
        if (alignmentPosition >= 0) {
            this._alignImportData(validFiles, prefix, alignmentPosition, 0);
        } else {
            this._performCallBackImport(validFiles);
        }
    }

    _alignImportData(validFiles, prefix, alignmentPosition, index) {
        var importItems = this.state.importStructure.importItems;
        const itemsLength = importItems.length;
        const importItem = importItems[index];
        const id = importItem.data[alignmentPosition].value.file1.split('_')[0].replace(prefix, '');
        var serviceResource = '/tree/saveAlignmentDocument/' + this.props.projectName + '/' + LexemeUtilities.encodeUrl(JSON.stringify(importItem.data[alignmentPosition].value)) + '/docx/' + id + '/null/true/';// + title + '/';
        Notifications.showModalSpinner('Allineamento dei documenti (' + (index + 1) + '/' + itemsLength + '), attendere');
        Dict.call(serviceResource).then((serviceResult) => {
            importItem.data[alignmentPosition].value.status = 'stored';
            delete importItem.data[alignmentPosition].value.originalStatus;
            if (index < (itemsLength - 1)) {
                this._alignImportData(validFiles, prefix, alignmentPosition, index + 1);
                /*this.setState({})*/
            } else {
                Notifications.closeModalSpinner();
                this._performCallBackImport(validFiles);
            }
        })
    }

    _retrieveAlignmentPosition(item) {
        return item.data.findIndex((itemData) => {
            return itemData.code === 'ALIGNMENT_DOCS';
        });
    }

    _performCallBackImport(validFiles) {
        this.props.callbackImport(this.state.importStructure.importItems, validFiles, this.state.importStructure.info.listFilesexpander);
    }

    _handleOpenViewer(event, item) {
        var element = TreeDOMHelper.resetNodePageContainer(event, "node-page");
        TreeDOMHelper.hideNodePageContainer();

        ReactDOM.unmountComponentAtNode(element);

        setTimeout(function () {

            var retrieveItem = new Promise((resolve) => {
                if (item.data === '')
                    return resolve(Dict.call('/tree/getItemDataByKey/' + this.props.projectName + '/' + item.key + '/'));
                else
                    return resolve(item.data);
            });

            retrieveItem.then((data) => {
                this.setState({data}, () => {
                    item.data = data;
                    ReactDOM.render(<TreeNodeEditor item={item}
                                                    numbering={NodeOperations.buildNumbering(this.props.treeStructure, item)}
                                                    isBasicItem={TreeNodeHelper.isBasicItem(item.code)}
                                                    projectName={this.props.projectName}
                                                    interfaceLang={this.props.interfaceLang}
                                                    treeStructure={this.props.treeStructure}
                                                    composedTreeItems={this.props.composedTreeItems}
                                                    composedCollections={this.props.composedCollections}
                                                    isViewer={true}
                                                    itemsToIcon={this.props.itemsToIcon}
                                                    autoincrement={parseFloat(this.props.autoincrement)}
                                                    callbackOpenEditItem={(event, item) => {
                                                        this._handleOpenEditItem(event, item);
                                                    }}
                                                    callbackOpenTreeLinks={(event, ids) => {
                                                        event.persist();
                                                        var treelinkPage = document.getElementById('node-treelink-page');//TreeDOMHelper.resetNodeTreeLinkContainer(event);

                                                        if (treelinkPage.classList.contains(stylesSCTree[treelinkPage.id + "--active"])) {
                                                            TreeDOMHelper.setElementToInActive(treelinkPage);
                                                            ReactDOM.unmountComponentAtNode(treelinkPage);
                                                        } else {
                                                            NodeOperations.getItemById(this.props.projectName, ids).then((item) => {
                                                                const ele = <TreeNodeEditor item={item}
                                                                                            numbering={NodeOperations.buildNumbering(this.props.treeStructure, item)}
                                                                                            isBasicItem={TreeNodeHelper.isBasicItem(item.code)}
                                                                                            projectName={this.props.projectName}
                                                                                            treeStructure={this.props.treeStructure}
                                                                                            interfaceLang={this.props.interfaceLang}
                                                                                            composedTreeItems={this.props.composedTreeItems}
                                                                                            isViewer={true}
                                                                                            isTreeLink={true}
                                                                                            autoincrement={this.props.autoincrement}
                                                                />;

                                                                TreeDOMHelper.setElementToActive(treelinkPage);
                                                                ReactDOM.render(ele, treelinkPage);
                                                                TreeDOMHelper.resetNodeTreeLinkContainer(event);
                                                            });
                                                        }
                                                    }
                                                    }/>, element, function () {
                        TreeDOMHelper.setElementToActive(element);
                        var reactTree = document.getElementsByClassName('react-tree')[0];
                        if ((parseFloat(element.offsetHeight) + parseFloat(element.style.top.replace('px', ''))) > reactTree.offsetHeight) {
                            document.getElementById('node-page').style.top = 150 + "px";
                            var setHeight = (document.getElementsByClassName('react-tree')[0].offsetHeight - 200) + "px";
                            document.querySelectorAll('.' + stylesSCTree['tree-object-element-container--overflow']).forEach(function (elem) {
                                elem.style.maxHeight = setHeight;
                            });
                        }
                        setTimeout(function () {
                            TreeDOMHelper.setOpenItemSkin();
                        }, 0);
                    });
                })
            })
        }.bind(this), 60);
    }

    _handleDoubleClick(evt, parentElement, item) {
        this._handleOpenViewer(evt, item);
    }

    _getIconByCode(code) {
        return this.props.itemsToIcon[code];
    }

    _handleRemoveItem(item, hasResourceFolders) {
        /*var removePromise = new Promise((resolve) => {
            if (hasResourceFolders) {
                return resolve(Dict.call('/tree/deleteMultimediaItem/' + this.props.projectName + '/' + item.key + '/'))
            } else {
                resolve();
            }
        });*/

        //removePromise.then(() => {
        this.props.callbackQuickSave();
        this.props.callbackRemove();
        //});

        TreeDOMHelper.hideNodePageContainer();
    }

    _toggleSelectItem(evt, item) {
        var parentElement = evt.target;
        while (!parentElement.classList.contains('react-tree-item-label')) {
            parentElement = parentElement.parentElement;
        }
        TreeDOMHelper.resetItemSelection(parentElement);
        const clientY = evt.clientY;

        // unico modo per far evidenziare la riga di selezione con tasto dx, sembra che il contextmenuprovider intercetti l'evento oncontextmenu
        if (evt.button === 2 && (this.isModifierOrAdministrator || this.isInserter)) {
            this.setState({showContextMenu: true}, () => {
                setTimeout(() => {
                    TreeDOMHelper.hideNodePageContainer();
                    parentElement.classList.add('react-tree-item-label-active');

                    //var containerItems = TreeNodeHelper.treeContainersItems.length;
                    var basicItems = TreeNodeHelper.treeBasicItems.length;
                    var composedItems = this.props.composedTreeItems.length;
                    var totLength = (parseFloat(basicItems) + parseFloat(composedItems)) * 31;

                    //TODO: forse non serve più (per ora ho commentato e messo false).
                    // Nel caso riattivalo ma da ridurre quel valore di '300' che schizza troppo in alto in certi casi
                    // Tuttavia, avendo tolto gli oggetti basic non dovrebbe essere più necessario o valore di spostamento molto basso (<100)
                    if (item.code === 'FOLDER' && false/*&& (window.innerHeight - clientY < totLength)*/) {
                        setTimeout(function () {
                            document.getElementsByClassName('react-contexify__submenu')[0].style.top = '-' + (totLength - 300) + 'px';
                            document.getElementsByClassName('react-contexify__submenu')[1].style.top = '-' + (totLength - 300) + 'px';
                        }.bind(this), 100);
                    }
                })
            }, 1000);
        } else {
            parentElement.classList.add('react-tree-item-label-active');

            if (item.code === 'FOLDER') {
                const threshold = 350;
                if (this.firstClick > 0) {
                    if ((new Date().getTime() - this.firstClick) < threshold)
                        this._handleDoubleClick(evt, parentElement, item);
                    this.firstClick = 0;
                } else {
                    this.firstClick = new Date().getTime();
                    setTimeout(function () {
                        this.firstClick = 0;
                    }.bind(this), threshold);

                }
            } else {
                this._handleDoubleClick(evt, parentElement, item);
            }

            /*location.hash = 'item-click-' + item.key;*/
            const el = document.getElementById('item-click-' + item.key);
            var parent = el.parentNode.parentNode;
            //parent.parentNode.parentNode.scrollIntoView({block: "start", behavior: "smooth"});
        }
    }

    _countChildren() {
        if (this.props.item.code === 'FOLDER' /*&& this.state.countChildren === 'calculating...'*/) {
            Dict.call('/tree/countNodeChildren/' + this.props.projectName + '/' + this.props.item.key + '/').then((result) => {
                this.setState({countChildren: Dict.t('NDOCUMENTS') + ':' + result}, () => {

                });
            })
        }
    }


    render() {

        var item = this.props.item;
        const isItemToPaste = item === this.props.itemsToPaste;

        const projectName = this.props.projectName;
        const showMenu = this.isLogged && this.state.showContextMenu;

        const isHidden = typeof item.hidden !== 'undefined' && item.hidden;
        const isHiddenBranch = typeof item.hiddenBranch !== 'undefined' && item.hiddenBranch;
        const isHiddenValue = isHidden ? 'hide' : 'show';
        const isFolder = item.code === 'FOLDER';

        const showHidePostdix = isFolder ? '_BRANCH' : '';
        const hideShowCheck = isFolder ? isHiddenBranch : isHidden;
        const i18nHideShow = (hideShowCheck ? 'SHOW' : 'HIDE') + showHidePostdix;

        var hideShowValid = true;
        var hasChildren = false;
        var hasItemToPaste = false;
        var hasLoadedChildren = false;

        if (showMenu && isFolder) {
            if (isHiddenBranch) {
                var parentKey = NodeOperations.retrieveParentKey(item);
                var parent = document.getElementById('item-click-' + parentKey);
                if (parent !== null && parent.classList.contains(stylesSCTree['react-tree-branch-item--true'])) {
                    hideShowValid = false;
                }
            }

            hasChildren = isFolder && !item.isLeaf;
            hasLoadedChildren = hasChildren && typeof item.children !== 'undefined';
            hasItemToPaste = typeof this.props.itemsToPaste !== 'undefined' && Object.keys(this.props.itemsToPaste).length > 0;
        }

//ecchimi
        /*
        <ReactTooltip id={'tooltip-path-not-found'} type='info' delayShow={20}
                                  className={"tree-tool-tip"}>{Dict.t(!this.isAdd && value.isUrl ? 'FOUND_URL' : 'PATH_NOT_FOUND')}</ReactTooltip>
        * */


        return <div id={'item-click-' + item.key} ancestors={item.ancestors}
                    className={BUtils.joinClasses(stylesSCTree['react-tree-item--' + isHiddenValue], stylesSCTree['react-tree-branch-item--' + isHiddenBranch])}
            /*onMouseOver={() => this._mouseOver()}*/
            /*onMouseEnter={() => this._mouseOver()}*/
                    onMouseUp={(evt) => this._toggleSelectItem(evt, item)}>
            <FontAwesome className={stylesSCTree['tree-node-fa']} name={this._getIconByCode(item.code)}/>
            {showMenu ? <>
                <ContextMenuProvider id={"sc-tree-node-context-menu-" + item.key} component="span"
                                     className={BUtils.joinClasses(stylesSCTree['tree_main_skin'], stylesSCTree['tree-node-context-menu'], stylesSCTree['tree-node-context-menu--' + (isFolder ? 'pure-node' : 'not-node')])}>
                    {item.title}
                </ContextMenuProvider>
            </> : <div
                className={BUtils.joinClasses(stylesSCTree['tree-node-context-menu'], stylesSCTree['tree-node-context-menu--' + (isFolder ? 'pure-node' : 'not-node')])}>{item.title}</div>}
            {showMenu && (this.isInserter || this.isModifierOrAdministrator) ?
                <ContextMenu id={"sc-tree-node-context-menu-" + item.key} animation={"pop"}
                >
                    {item.code === 'FOLDER' ? <><Item>
                        {this.state.countChildren}
                    </Item>
                        <Separator/></> : ''}
                    {typeof item.code !== 'undefined' && item.code === 'FOLDER' ?
                        <Submenu label={Dict.t('ADD')}
                                 className={"submenu-will-overflow-" + this.state.subMenuWillOverflow}>
                            <Item
                                onClick={({
                                              event,
                                              ref,
                                              data,
                                              dataFromProvider
                                          }) => this._handleOpenContextMenuItem(event, TreeNodeHelper.treeNodeOperations.ADD, item)}><FontAwesome
                                className={"context-menu-fa"} name={"folder-open"}/>{Dict.t('FOLDER')}
                            </Item>
                            {/*<Separator/>*/}
                            {this.props.composedTreeItems.map((ctiItem) => {
                                return <Item className="context-add-item" key={"key-contextmenu-" + ctiItem.code}
                                             onClick={({
                                                           event,
                                                           ref,
                                                           data,
                                                           dataFromProvider
                                                       }) => this._handleOpenContextMenuItem(event, TreeNodeHelper.treeNodeOperations.ADD, item, ctiItem, false)}>
                                    <FontAwesome className={"context-menu-fa"}
                                                 name={ctiItem.icon}/>{TreeNodeHelper.getCtiLabel(ctiItem)}
                                </Item>
                            })}
                        </Submenu> : ""}
                    {typeof item.code !== 'undefined' && item.code === 'FOLDER' ?
                        <Submenu label={Dict.t('IMPORT')}
                                 className={"submenu-will-overflow-" + this.state.subMenuWillOverflow}>
                            {/*<Separator/>*/}
                            {this.props.composedTreeItems.map((ctiItem) => {
                                return <Item className="context-add-item" key={"key-contextmenu-" + ctiItem.code}
                                             onClick={({
                                                           event,
                                                           ref,
                                                           data,
                                                           dataFromProvider
                                                       }) => this._handleOpenImportItem(event, TreeNodeHelper.treeNodeOperations.IMPORT, item, ctiItem, false)}>
                                    <FontAwesome className={"context-menu-fa"}
                                                 name={ctiItem.icon}/>{TreeNodeHelper.getCtiLabel(ctiItem)}
                                </Item>
                            })}
                        </Submenu> : ""}
                    {this.isModifierOrAdministrator ? <Item // EDITA
                        onClick={({
                                      event,
                                      ref,
                                      data,
                                      dataFromProvider
                                  }) => this._handleOpenEditItem(event, item)}>{Dict.t('EDIT')}
                    </Item> : ''}
                    {this.isModifierOrAdministrator && isFolder ? <Item // EDITA
                        onClick={({
                                      event,
                                      ref,
                                      data,
                                      dataFromProvider
                                  }) => this._handleDocsAnalyze(event, item)}>{Dict.t('DOCS_ANALYZE')}
                    </Item> : ''}
                    {this.isModifierOrAdministrator ? <Separator/> : ''}
                    {typeof item.code !== 'undefined' && this.isModifierOrAdministrator && !isFolder ? <Item // TAGLIA
                        onClick={({
                                      event,
                                      ref,
                                      data,
                                      dataFromProvider
                                  }) => this._handleCopyItems(item, false)}>{Dict.t('COPY')}
                    </Item> : ''}
                    {typeof item.code !== 'undefined' && this.isModifierOrAdministrator && hasChildren ? <Item // TAGLIA
                        onClick={({
                                      event,
                                      ref,
                                      data,
                                      dataFromProvider
                                  }) => this._handleCopyItems(item, true)}>{Dict.t('COPY_CONTENTS')}
                    </Item> : ''}
                    {typeof item.code !== 'undefined' && this.isModifierOrAdministrator ? <Item // TAGLIA
                        onClick={({
                                      event,
                                      ref,
                                      data,
                                      dataFromProvider
                                  }) => this._handleCutItems(item, false)}>{Dict.t('CUT')}
                    </Item> : ''}
                    {typeof item.code !== 'undefined' && this.isModifierOrAdministrator && hasChildren ? <Item // TAGLIA
                        onClick={({
                                      event,
                                      ref,
                                      data,
                                      dataFromProvider
                                  }) => this._handleCutItems(item, true)}>{Dict.t('CUT_CONTENTS')}
                    </Item> : ''}
                    {typeof item.code !== 'undefined' && this.isModifierOrAdministrator && item.code === 'FOLDER' && hasItemToPaste ?
                        <Item // TAGLIA
                            onClick={({event, ref, data, dataFromProvider}) => this._handlePasteItem(item)}>
                            <strong>{Dict.t(this.props.cutPasteType === 'CUT_CHILDREN' || this.props.cutPasteType === 'COPY_CHILDREN' ? 'PASTE_CONTENTS' : 'PASTE')}
                            </strong>
                        </Item> : ''}
                    {typeof item.code !== 'undefined' && this.isModifierOrAdministrator && (typeof this.props.itemsToPaste !== 'undefined' && this.props.itemsToPaste !== '') ?
                        <Item // TAGLIA
                            onClick={({event, ref, data, dataFromProvider}) => this._resetCut()}>{Dict.t('RESET_CUT')}
                        </Item> : ''}
                    {<Separator/>}
                    {typeof item.code !== 'undefined' && this.isModifierOrAdministrator && hideShowValid ?
                        <Item // ORDINA MOSTRA/NASCONDI
                            onClick={({
                                          event,
                                          ref,
                                          data,
                                          dataFromProvider
                                      }) => this._handleShowHideItem(event, item)}>{Dict.t(i18nHideShow)}
                        </Item> : ''}
                    {!this.props.isAutomaticAlphabetic && typeof item.code !== 'undefined' && hasLoadedChildren && item.code === 'FOLDER' && this.isModifierOrAdministrator ?
                        <Item // ORDINA SORT
                            onClick={({
                                          event,
                                          ref,
                                          data,
                                          dataFromProvider
                                      }) => this._handleOpenSortItems(event, item.children)}>{Dict.t('SORT')}
                        </Item>
                        : ''}
                    {!this.props.isAutomaticAlphabetic && typeof item.code !== 'undefined' && hasLoadedChildren && item.code === 'FOLDER' && this.isModifierOrAdministrator ?
                        <Item // ORDINA SORT ALFABETICO
                            onClick={({
                                          event,
                                          ref,
                                          data,
                                          dataFromProvider
                                      }) => this._handleOpenSortItems(event, item.children, true)}>{Dict.t('ALPHABETIC_SORT')}
                        </Item>
                        : ''}
                    {typeof item.code !== 'undefined' && this.isModifierOrAdministrator && TreeNodeHelper.isRootItem(item) ?
                        <Item // ORDINA SORT RADICI
                            onClick={({
                                          event,
                                          ref,
                                          data,
                                          dataFromProvider
                                      }) => this._handleOpenSortItems(event, this.props.treeStructure)}>{Dict.t('SORT_ROOTS')}
                        </Item> : ''}
                    {this.isModifierOrAdministrator ? <Item onClick={({event, ref, data, dataFromProvider}) => {   //CANCELLA
                        var retrieveMultimediaDir = new Promise((resolve) => {
                            if (item.code === 'FOLDER') {
                                return resolve(Dict.call('/tree/nodeHasMultimediaDirectories/' + projectName + '/' + item.key + '/'));
                            } else if (typeof item.data !== 'undefined' && item.data !== '') {
                                var count = item.data.filter(dataItem => {
                                    return dataItem.type === 'dropzone';
                                });
                                return resolve({hasMultimediaDirectories: count.length > 0});
                            }
                        });

                        retrieveMultimediaDir.then((res) => {
                            const AlertResources = res.hasMultimediaDirectories ?
                                <span id="span-remove-node-alert"
                                      className={stylesSCTree['div-remove-node__alert']}>[{Dict.t('ALERT_NODE_HAS_RESOURCES')}]</span> : '';

                            TreeDOMHelper.hideNodePageContainer();
                            var ele = TreeDOMHelper.resetNodePageContainer(event, "node-operations-container");
                            const div = <div id="div-remove-node-container"
                                             className={stylesSCTree['div-remove-node']}>
                                <span
                                    className={stylesSCTree['div-remove-node__ask']}>{Dict.t('ASK_DELETE_NODE')}</span>
                                {AlertResources}
                                <button onClick={() => {
                                    this._handleRemoveItem(item, res.hasMultimediaDirectories);
                                }}>{Dict.t('YES')}
                                </button>
                                <span className={stylesSCTree['div-remove-node__separator']}>/</span>
                                <button onClick={() => {
                                    TreeDOMHelper.hideNodePageContainer()
                                }}>{Dict.t('NO')}</button>
                            </div>;

                            ReactDOM.render(div, ele);
                        });
                    }}>{Dict.t('REMOVE')}
                    </Item> : ''}
                    { /*<Separator />*/}
                </ContextMenu> : ''}
            {isItemToPaste ? <FontAwesome name={this.props.cutPasteType === 'CUT_CHILDREN' ? "scissors" : "clone"}
                                          style={{marginLeft: '5px', marginRight: '3px'}}/> : ''}
            {isItemToPaste && this.props.cutPasteType.endsWith('_CHILDREN') ?
                <FontAwesome name={"list"} style={{marginLeft: '1px', marginRight: '3px'}}/> : ''}
            <FontAwesome name={"eye-slash"} className={stylesSCTree['react-tree-item-icon--' + isHiddenValue]}/>
            <FontAwesome id={'loading-key-spin-' + item.key} className={'loading-key-spin'}
                         style={{display: 'none'}} name={'spinner'} spin/>
        </div>;
    }
}


class TreeNodeEditor extends React.Component {

    constructor(props) {
        super(props);

        this.isAdd = this.props.operation === TreeNodeHelper.treeNodeOperations.ADD;
        //this.maxHeight = (document.getElementsByClassName('react-tree')[0].offsetHeight - 200) + "px";
        this.isLogged = userService.isLogged();

        this.state = {
            treeStructure: this.props.treeStructure,
            composedCollections: this.props.composedCollections,
            title: this.isAdd ? '' : this.props.item.title,
            code: typeof this.props.treeObject === 'undefined' ? 'FOLDER' : this.props.treeObject.code,
            data: typeof this.props.item.data === 'undefined' ? '' : JSON.parse(JSON.stringify(this.props.item.data)),
            item: JSON.parse(JSON.stringify(this.props.item)),
            anomaly: {hasAnomaly: false, type: ''},
            isRootNode: NodeOperations.retrieveParentKey(this.props.item) == null,
            isBasicItem: this.props.isBasicItem,
            interfaceLang: '',
            isViewer: this.props.isViewer,
            previewCarouselItems: [],
            storedCarouselItems: [],
            toDeleteCarouselItems: [],
            carouselCode: '',
            carouselPosition: 0,
            carouselActiveIndex: 0,
            showTreeCarousel: 'none',
            /*serverUrl: BUtils.getServerUrl(), //Dict.getGlobalProperty('SERVER_URL'),*/
            resourceElementsPosition: [],
            hasAlignment: false,
            treeLinkOptions: [],
            opening: true,
            previousSibling: '',
            nextSibling: '',
            alignmentInfos: {
                status: 'checking',
                style: 'warning',
                text: Dict.t('CHECKING_ALIGMENT'),
                isServiceActive: true
            },
            originalHtml: ''
            /*doc: {filename: '', src: '', pageNumber: 1, numbPages: -1}*/
        };

        this.parent = {};

        this._save = this._save.bind(this);
        this._drawTreeElementObject = this._drawTreeElementObject.bind(this);
        this._openEditCarousel = this._openEditCarousel.bind(this);
        this._openCarouselByIndex = this._openCarouselByIndex.bind(this);
        this._retrieveElementEdit = this._retrieveElementEdit.bind(this);
        this._openDocumentPreview = this._openDocumentPreview.bind(this);
    }

    componentWillMount() {

        NodeOperations.retrieveItemData(this.props.projectName, this.props.item).then((data) => {
            var item = this.props.item;
            item.data = data;
            //var data = item.data;

            this.setState({item, data}, () => {
                var resourceElementsPosition = [];
                var data = [];
                var hasAlignment = false;

                if (this.isAdd && typeof this.props.treeObject !== 'undefined') {
                    this.props.treeObject.basicItems.map((item, index) => {
                        if (item.item.code === 'ALIGNMENT_DOCS')
                            hasAlignment = true;
                        this._pushBasicDataItem(item, resourceElementsPosition, data, index);
                    });
                    this.setState({data, resourceElementsPosition, hasAlignment});
                } else if (typeof this.props.item.data !== 'undefined' && this.props.item.data.length > 0) {
                    const composedBasicItems = this.props.composedTreeItems.filter((myItem) => {
                        return myItem.code === item.code;
                    })[0].basicItems;

                    composedBasicItems.forEach((basicItem, index) => {
                        var resourcePositionFound;
                        data = this.state.data;
                        resourcePositionFound = typeof basicItem.item !== 'undefined' && basicItem.item.element.type === 'dropzone';
                        if (resourcePositionFound) {
                            resourceElementsPosition.push(index);
                        }
                        if (basicItem.item.code === 'ALIGNMENT_DOCS')
                            hasAlignment = true;

                        var dataItem = data.find((dataItem) => {
                            return dataItem.id === basicItem.id;
                        });

                        if (typeof dataItem !== 'undefined') {
                            dataItem.label = basicItem.i18nLabels['it'];
                        } else {
                            //this._pushBasicDataItem(basicItem, resourceElementsPosition, data, index);
                            var element = {
                                id: basicItem.id + '',
                                label: basicItem.i18nLabels['it'/*this.props.interfaceLang*/],
                                type: basicItem.item.element.type,
                                code: basicItem.item.code,
                                value: '',
                                basicItemHidden: basicItem.hidden
                            };

                            if (basicItem.item.element.type === 'dropzone') {
                                element.accept = basicItem.item.element.accept;
                            }

                            if (basicItem.item.element.type === 'autocomplete') {
                                //element.id = basicItem.item.element.id;
                                if (typeof basicItem.item.element.collectionId !== 'undefined') {
                                    element.collectionId = basicItem.item.element.collectionId;
                                }
                            }
                            data.splice(index, 0, element);
                        }

                    });
                }

                this.setState({data, resourceElementsPosition, hasAlignment});
            });
        });
    }

    componentDidMount() {

        if (this.props.isViewer) {
            this._dragElement('node-page', 'title-viewer');
        } else {
            const node = ReactDOM.findDOMNode(this.formControl);
            node.value = '';
            node.focus();
            node.value = this.isAdd ? '' : this.state.item.title;

            if (!this.state.isRootNode && !this.props.isViewer) {
                NodeOperations.retrieveParentItem(this.state.treeStructure, this.props.item, (parent) => {
                    this.parent = parent;
                });
            }

            this._dragElement('node-operations-container', 'node-operations-container__header');

            if (Dict.getGlobalProperty('ACTIVE_DOC_ALIGNMENT') && this.props.item.code !== 'FOLDER') {
                this._checkAligned(true);
            }
        }

        setTimeout(function () {
            TreeDOMHelper.setSkin();
        }, 0);

        NodeOperations.retrieveParentItem(this.props.treeStructure, this.props.item, (parent) => {
            var previousSibling = TreeNodeHelper.getPreviousChild(parent, this.props.item);
            var nextSibling = TreeNodeHelper.getNextChild(parent, this.props.item);

            this.setState({previousSibling, nextSibling});
        });
    }

    _checkAligned(checkConnection) {
        const fetchData = async () => {
            try {

                checkConnection = true;
                var urls = ['/tree/alignmentService/isAligned/' + this.props.projectName + '/' + this.props.item.key + '/'];
                if (checkConnection) {
                    urls = ['/tree/alignmentService/checkAlignServiceActive'].concat(urls);
                }

                await Promise.all(urls.map(url => Dict.call(url))).then(multiResult => {
                    var result = checkConnection ? multiResult[1] : multiResult[0]


                    const status = result.result === 'OK' ? 'aligned' : 'not_aligned';
                    const isServiceActive = checkConnection ? multiResult[0].result === 'OK' : true

                    const style = result.result === 'OK' ? 'success' : 'danger';
                    const text = Dict.t(result.result === 'OK' ? 'DOCS_ALIGNED' : 'DOCS_NOT_ALIGNED');
                    const alignmentInfos = {status, style, text, isServiceActive}
                    this.setState({alignmentInfos});
                    return alignmentInfos;

                });
            } catch (err) {
                console.log(err);
                const alignmentInfos = {
                    status: 'not_aligned',
                    style: 'danger',
                    text: Dict.t('DOCS_NOT_ALIGNED'),
                    isServiceActive: false
                };
                this.setState({alignmentInfos});
            }
        }

        return fetchData();
    }

    _dragElement(elementId, headerId) {
        const elmnt = document.getElementById(elementId);

        var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
        if (document.getElementById(headerId)) {
            // if present, the header is where you move the DIV from:
            document.getElementById(headerId).onmousedown = dragMouseDown;
        } else {
            // otherwise, move the DIV from anywhere inside the DIV:
            elmnt.onmousedown = dragMouseDown;
        }

        function dragMouseDown(e) {
            e = e || window.event;
            e.preventDefault();
            // get the mouse cursor position at startup:
            pos3 = e.clientX;
            pos4 = e.clientY;
            document.onmouseup = closeDragElement;
            // call a function whenever the cursor moves:
            document.onmousemove = elementDrag;
        }

        function elementDrag(e) {
            e = e || window.event;
            e.preventDefault();
            // calculate the new cursor position:
            pos1 = pos3 - e.clientX;
            pos2 = pos4 - e.clientY;
            pos3 = e.clientX;
            pos4 = e.clientY;
            // set the element's new position:
            elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
            elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
        }

        function closeDragElement() {
            // stop moving when mouse button is released:
            document.onmouseup = null;
            document.onmousemove = null;
        }
    }

    _pushBasicDataItemToContainer(item, resourceElementsPosition, data, index) {
        var element = {
            label: item.label,
            type: item.type,
            code: item.code,
            value: ''
        };

        if (item.type === 'dropzone') {
            resourceElementsPosition.push(index);
            element.accept = item.accept;
        }

        data.push(element);
    }

    // PUSH DATA
    _pushBasicDataItem(basicItem, resourceElementsPosition, data, index) {
        var element = {
            id: basicItem.id + '',
            label: basicItem.i18nLabels['it'/*this.props.interfaceLang*/],
            type: basicItem.item.element.type,
            code: basicItem.item.code,
            value: '',
            basicItemHidden: basicItem.hidden
        };

        if (basicItem.item.element.type === 'dropzone') {
            element.accept = basicItem.item.element.accept;
        }

        if (basicItem.item.element.type === 'autocomplete') {
            //element.id = basicItem.item.element.id;
            if (typeof basicItem.item.element.collectionId !== 'undefined') {
                element.collectionId = basicItem.item.element.collectionId;
            }
        }

        //data.push(element);
        data.splice(index, 0, element);
    }

    _drawTreeElementObject() {
        const isViewer = this.props.isViewer;
        const isEdit = !isViewer;
        const isLogged = this.isLogged;
        /*const composedItem = this.props.composedTreeItems.find((compoItem) => {
            return compoItem.code === (this.props.item.code;
        });*/

        return this.state.data.map((dataItem, indexData) => {
            var counter = this.state.data.indexOf(dataItem);
            var isHidden = (this.state.data[counter].basicItemHidden || this.state.data[counter].hidden);
            var hasValue = this._elementHasValue(dataItem);

            var show = isEdit || (hasValue && (isLogged || !isHidden));

            if (show) {
                //if (/*this.isLogged ||*/ !this.props.isViewer || (!isHidden && hasValue)) {
                var id = this.state.item.key + "-" + counter;

                var element = this.props.isViewer ? this._retrieveElementViewer(id, counter, isHidden) : this._retrieveElementEdit(id, counter, this.state.data[counter].basicItemHidden);

                var longWidthItems = ['autocomplete', 'pathbrowser', 'dropzone'];
                var longWidthClass = longWidthItems.includes(dataItem.type) ? 'longWidth-item' : '';

                var tovRowClassName = this.props.isViewer ? stylesSCTree['tree-object-viewer'] : '';

                return <Row key={"key-tree-object-row-" + counter}
                            className={BUtils.joinClasses(stylesSCTree['tree-object-row'], stylesSCTree['tree-object-row--' + (this.props.isViewer ? 'viewer' : 'edit')], (this.props.isBasicItem ? (stylesSCTree['tree-object-row--basic-' + dataItem.type]) : ''), tovRowClassName, longWidthClass)}>
                    {element}
                </Row>
            }
        });
    }

    _elementHasValue(dataItem) {
        if (dataItem.type === 'checkbox') {
            return true;
        } else if (dataItem.type === 'autocomplete') {
            return dataItem.itemIdSelected > 0;
        } else if (dataItem.type === 'pathbrowser') {
            return (typeof dataItem.value !== 'undefined' && dataItem.value.path !== '' && typeof dataItem.value.path !== 'undefined');
        } else {
            return typeof dataItem.value !== 'undefined' && Object.keys(dataItem.value).length > 0
        }
    }

    _drawEditGallery() {
        var carouselItemsArray = [];
        var title = "";

        if (this.state.showTreeCarousel === 'stored') {
            carouselItemsArray = this.state.storedCarouselItems;
            title = "STORED_FILE_GALLERY";
        } else if (this.state.showTreeCarousel === 'preview') {
            carouselItemsArray = this.state.previewCarouselItems;
            title = "FILE_PREVIEW_GALLERY";
        } else if (this.state.showTreeCarousel === 'toDelete') {
            carouselItemsArray = this.state.toDeleteCarouselItems;
            title = "FILE_TO_DELETE_GALLERY";
        }

        var data = this.state.data;

        const carouselItems = carouselItemsArray.map((item, index) => {
            var dataCounter = data[this.state.carouselPosition];

            var status = this.state.showTreeCarousel !== 'preview' && typeof dataCounter.value !== 'undefined' ? dataCounter.value[index].status : undefined;

            var Component;
            if (this.state.carouselCode === 'AUDIO_GALLERY') {
                Component = <audio className={"tree-carousel-audio"} src={item} controls="controls"/>;
            } else if (this.state.carouselCode === 'VIDEO_GALLERY') {
                Component = <video className={stylesSCTree['tree-carousel-video']} src={item} controls="controls"/>;
            } else {
                Component = <Image className={"tree-carousel-img"} src={item} responsive/>;
            }

            return <CarouselItem key={"key-carousel-item-" + index}>
                <div
                    className={stylesSCTree['tree-object-viewer__carousel-container'] + ' ' + this.state.showTreeCarousel}>
                    {this.state.showTreeCarousel === 'stored' ?
                        <Row className={stylesSCTree['tree-carousel-row-chk']}>
                            <SCCheckbox label={Dict.t('INTO_DELETE_LIST')}
                                        id={"chk-to-delete-" + index}
                                        checked={typeof status !== 'undefined' && status === 'to_remove'}
                                        callbackParent={(id, newState) => {
                                            var toDeleteCarouselItems = this.state.toDeleteCarouselItems;

                                            if (newState) {
                                                toDeleteCarouselItems.push(item);
                                                dataCounter.value[index].status = "to_remove";
                                            } else {
                                                toDeleteCarouselItems.splice(toDeleteCarouselItems.indexOf(item), 1);
                                                delete dataCounter.value[index].status;
                                            }

                                            this.setState({
                                                toDeleteCarouselItems, data
                                            })
                                        }
                                        }>
                            </SCCheckbox>
                        </Row> : ""}
                    {Component}
                </div>
            </CarouselItem>;
        });

        return <div id={"tree-carousel-drop-container"}
                    className={BUtils.joinClasses(stylesSCTree['tree-carousel-drop-container'], stylesSCTree['tree-carousel-drop-' + this.state.showTreeCarousel])}>
            <Row id={"tree-carousel-bar"} className={stylesSCTree['tree-carousel-drop-container__row']}>
                <span id="tree-carousel-bar-title"
                      className={stylesSCTree['tree-carousel-bar__title']}>{Dict.t(title)}</span>
                <Button className={stylesSCTree['tree-carousel-bar__button']}
                        onClick={(evt) => {
                            this.setState({showTreeCarousel: 'none', activeIndex: 0})
                        }}><FontAwesome name="close"/></Button></Row>
            <Row className={stylesSCTree['tree-carousel-drop-container__row']}>
                <Carousel id={"tree-carousel-drop"} className={stylesSCTree['tree-carousel-drop']}
                          defaultActiveIndex={this.state.activeIndex}
                          slide={true} interval={null} controls={carouselItemsArray.length > 1}
                          indicators={carouselItemsArray.length > 1}>
                    {carouselItems}
                </Carousel>
            </Row>
        </div>
    }

    _buildShiftButton(item, symbol) {
        var shiftButton = '';
        if (typeof item !== 'undefined' && item !== null && item !== '') {
            shiftButton = <Button
                onClick={(evt) => {

                    var evtMouse = document.createEvent("MouseEvents");
                    evtMouse.initEvent("mouseup", true, true);
                    evtMouse.dataTransfer = {shift: true};
                    document.getElementById('item-click-' + item.key).dispatchEvent(evtMouse);

                }}
                bsStyle={"primary"}>{symbol}</Button>
        }

        return shiftButton;
    }

    _drawButtonBar() {

        const nextSibling = this.state.nextSibling;
        var nextButton = this._buildShiftButton(nextSibling, '>>>>');
        const previousSibling = this.state.previousSibling;
        var prevButton = this._buildShiftButton(previousSibling, '<<<<');

        var item = this.state.item;

        return <div id="add-element-buttonbar" className={stylesSCTree['add-element-buttonbar']}>
            {this.props.isViewer ? '' :
                <Button id={'add-element-buttonsave'}
                        onClick={(evt) => {
                            (this.state.resourceElementsPosition).length > 0 || this.state.hasAlignment ? this._saveResource(item) : this._save(item);
                        }
                        }
                        bsStyle={"primary"}>{Dict.t('SAVE')}</Button>}
            {userService.isLogged() && this.props.isViewer ? <Button onClick={(event) => {
                this.props.callbackOpenEditItem(event, item)
            }}>{Dict.t('EDIT')}</Button> : ''}
            {this.props.isViewer ? <>{prevButton}
                {nextButton}</> : ''}
            {this.props.isTreeLink ? '' : <Button onClick={(evt) => TreeDOMHelper.hideNodePageContainer()}
                                                  bsStyle={"primary"}>{Dict.t('CLOSE')}</Button>}
        </div>
    }

    _addAutocompleteCustomItem(data, counter) {
        var dataCounter = data[counter];
        var items = dataCounter.items;

        if (dataCounter.tmpData.addAutocompleteText.trim().length > 0) {
            if (items.filter((item) => {
                return item.label === dataCounter.tmpData.addAutocompleteText;
            }).length > 0) {
                Notifications.showErrorModalMessage("ITEM_ALREADY_EXISTS_IN_COLLECTION", 3000);
            } else {
                dataCounter.tmpData.startInsert = true;
                items.push({
                    id: parseInt(items.length) + 1,
                    label: dataCounter.tmpData.addAutocompleteText
                });

                this.setState({data});
                setTimeout(function () {
                    dataCounter.tmpData.startInsert = 'hidden';
                    dataCounter.tmpData.addAutocompleteText = '';
                    setTimeout(function () {
                        dataCounter.tmpData.startInsert = false;
                        dataCounter.tmpData.addAutocompleteText = '';
                        this.setState({data});
                    }.bind(this), 300);
                    this.setState({data});
                }.bind(this), 300);
            }
        }
    }


    // EDITA ELEMENTO
    _retrieveElementEdit(id, counter, isBasicItemHidden) {
        var data = ({}, this.state.data); //BUtils.cloneJson(this.state.data);
        const type = data[counter].type;
        var value = data[counter].value;
        const isBasicItem = this.state.isBasicItem;
        const isHidden = data[counter].hidden === true;
        //const isBasicItemHidden = data[counter].basicItemHidden;

        const composedItem = TreeNodeHelper.getItemByCode(this.props.item.code, this.props.composedTreeItems);


        var retElement = '';
        var colLeft = 3;
        var colRight = 9;
        var additionalColLeft = '';
        var additionalColRight = '';
        var label = '';

        if (type === 'textfield' || type === 'weblink') {
            label = data[counter].label;
            retElement = <InputGroup className={stylesSCTree['teb-' + type]}>
                <FormControl
                    id={id}
                    componentClass="textarea"
                    className={stylesSCTree['teb-textfield__textarea']}
                    aria-label="With textarea"
                    placeholder={''}
                    ref={(input) => {
                        this['formControl-' + id] = input;
                    }}
                    value={value}
                    onChange={(evt) => {
                        data[counter].value = evt.target.value;

                        this.setState({data});
                    }}
                    onKeyDown={() => {
                    }}
                />
            </InputGroup>;
        } else if (type === 'tinymce') {
            label = data[counter].label;
            retElement = <Editor
                id={id}
                initialValue={value}
                init={{
                    plugins: 'link image code sccharmap',
                    toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | code | sccharmap'
                }}
                onChange={(evt) => {
                    data[counter].value = evt.target.getContent();
                    this.setState({data});
                }}
            />
        } else if (type === 'datepicker') {
            /*colLeft = 2;
            colRight = 10;*/
            label = data[counter].label;
            var choosenMode = data[counter].choosenMode;
            if (typeof choosenMode === 'undefined')
                choosenMode = TreeNodeHelper.getBasicItemByCode(data[counter].code).element.mode[0].code;

            var inputType = 'date';
            if (choosenMode === 'mm-yyyy')
                inputType = 'month';
            else if (choosenMode === 'yyyy')
                inputType = 'number';

            var dateValue = TreeUtilities.writeDateStringForInput(value, choosenMode);
            retElement = <div className={stylesSCTree['teb-datepicker']}>
                <Col lg={4} md={4} className={stylesSCTree['teb-datepicker__col-input']}>
                    <input id={id} type={inputType} className={stylesSCTree['teb-datepicker__input']} value={dateValue}
                           onChange={(evt) => {
                               data[counter].value = inputType === 'number' ? evt.target.value : new Date(evt.target.value).toISOString();
                               this.setState({data});
                           }}/>
                </Col>
                <Col lg={8} md={8} className={stylesSCTree['teb-datepicker__col-radio']}>
                    <SCRadiobutton default={choosenMode}
                                   label={Dict.t('FORMAT')}
                                   i18nLabel={true}
                                   id={'teb-datepicker-mode'}
                                   additionalClass={stylesSCTree['teb-datepicker-mode']}
                                   items={TreeNodeHelper.getBasicItemByCode(data[counter].code).element.mode}
                                   bsStyle="default"
                                   callbackParent={(newState) => {
                                       data[counter].choosenMode = newState;
                                       this.setState({data});
                                   }}/>
                </Col>
            </div>;
        } else if (type === 'pdf-page-number') {
            /*colLeft = 2;
            colRight = 10;*/
            label = data[counter].label;

            const openViewerDocButtonId = 'open-viewer-doc-' + id;

            retElement = <div key={'open-viewer-doc-key'} className={stylesSCTree['tree-docs-viewer-item']}>
                <input id={id} type={'number'} className={stylesSCTree['teb-datepicker__input']} value={value}
                       onChange={(evt) => {
                           data[counter].value = evt.target.value;
                           this.setState({data});
                       }}/>
                <div className={stylesSCTree['tree-docs-viewer-item__buttons']}
                     style={{verticalAlign: 'top', marginLeft: '3px'}}>
                    <Button id={openViewerDocButtonId}
                            onClick={() => {

                                const isAdd = this.props.operation === 'add';
                                //NodeOperations.retrieveParentItem(this.props.treeStructure, this.props.item, (parent) => {
                                var val = this.props.item.data.find((item) => {
                                    return item.type === (isAdd ? 'dropzone' : type);
                                });

                                var src;
                                if (!isAdd) {
                                    const ancestors = this.props.item.ancestors;
                                    var folder = (ancestors).split("_")[(ancestors).split("_").length - 1];
                                    var item = {};
                                    item.value = [val.resource];
                                    data.folder = folder;
                                    src = TreeUtilities.buildMultimediaSrc(this.props.projectName, val.resource, data);
                                    this._createEditDocumentOnClick(src, openViewerDocButtonId, item.value[0], val.value[0], folder);

                                } else {
                                    src = this._buildSrc(val.value[0], val);
                                    this._createEditDocumentOnClick(src, openViewerDocButtonId, val.value[0], data[counter].value[0], this.props.item.key);
                                }

                                //})
                            }}>{Dict.t('SHOW')}</Button>
                </div>
            </div>;

        } else if (type === 'checkbox') {
            /*colLeft = 4;
            colRight = 8;*/
            label = data[counter].label;
            retElement =
                <SCCheckbox id={id} checked={typeof value === 'undefined' ? false : value}
                            additionalClass={stylesSCTree['teb-checkbox']}
                            callbackParent={(id, newState) => {
                                data[counter].value = newState;
                                this.setState({data});
                            }}/>
        } else if (type === 'autocomplete') {
            /*colLeft = 4;
            colRight = 8;*/

            if (typeof data[counter].tmpData === 'undefined') {
                data[counter].tmpData = {};
            }

            label = data[counter].label;
            var itemIdSelected = data[counter].itemIdSelected;
            var ref = "single-autocomplete-" + counter;
            var itemSelected;
            var selected = [];
            var startInsert = typeof data[counter].tmpData.startInsert === 'undefined' ? 'not-set' : data[counter].tmpData.startInsert;

            const isCustom = data[counter].code === 'CUSTOM_DATA_COLLECTION';

            if (isCustom) {
                additionalColLeft = stylesSCTree["tree-object-wrapper__col-left-autocomplete"];
                additionalColRight = stylesSCTree["tree-object-wrapper__col-right-autocomplete"];

                if (typeof data[counter].customLabel === 'undefined')
                    data[counter].customLabel = '';
                if (typeof data[counter].items === 'undefined')
                    data[counter].items = [];

                const collection = TreeUtilities.extractItemsByComposedCollection(data[counter].collectionId, this.props.composedCollections)

                itemSelected = typeof data[counter].itemIdSelected === 'undefined' ? [] : [TreeNodeHelper.getAutoCompleteItemById(collection.items, data[counter].itemIdSelected)];

                retElement = <Row>
                    <Col lg={8} md={8} className={stylesSCTree['teb-autocomplete-add']}>
                        <FormControl
                            id={id}
                            type="text"
                            className={stylesSCTree['teb-autocomplete-add__input-custom-label']}
                            placeholder={'etichetta viewer'}
                            ref={(input) => {
                                this['formControl-autocomplete-' + counter] = input;
                            }}
                            value={data[counter].customLabel}
                            onChange={(evt) => {
                                data[counter].customLabel = evt.target.value;
                                this.setState({data});
                            }}
                            /*onKeyDown={() => {
                            }}*/
                        />
                        <input id={id + "-input-data"} type="text"
                               className={BUtils.joinClasses(stylesSCTree['teb-autocomplete-add__input-add'], stylesSCTree['teb-autocomplete-add__input-add--start-insert-' + startInsert])}
                               value={data[counter].tmpData.addAutocompleteText}
                               placeholder="aggiungi alla collezione"
                               onKeyUp={(evt) => {
                                   if (evt.keyCode === 13)
                                       this._addAutocompleteCustomItem(data, counter);
                               }}
                               onChange={(evt) => {
                                   data[counter].tmpData.addAutocompleteText = evt.target.value;
                                   this.setState({data});
                               }}/>
                        <Button className={stylesSCTree['teb-add-autocomplete__button-add']}
                                onClick={(evt) => this._addAutocompleteCustomItem(data, counter)}>>></Button>
                    </Col>
                    <Col lg={4} md={4}>
                        <Typeahead
                            id={'teb-autocomplete-' + data[counter]}
                            ref={(typeahead) => this[ref] = typeahead}
                            clearButton
                            className={BUtils.joinClasses(stylesSCTree['teb-autocomplete'], stylesSCTree['teb-autocomplete--start-insert-' + startInsert])}
                            onChange={item => {
                                if (typeof item[0] === 'undefined')
                                    delete data[counter].itemIdSelected;
                                else
                                    data[counter].itemIdSelected = item[0].id;

                                this.setState({data});
                            }}
                            onSearch={() => {
                                return;
                            }}
                            options={collection}
                            selected={itemSelected}
                            placeholder={!isCustom && !isBasicItem ? preCollectionLabelType : Dict.t('COLLECTION')}
                        />
                        <Button className={stylesSCTree['teb-add-autocomplete__button-remove']} onClick={() => {
                            data[counter].items.splice(data[counter].items.findIndex(function (item) {
                                return item.id === itemIdSelected;
                            }, 1));
                            delete data[counter].itemIdSelected;
                            this.setState({data}, function () {
                                this[ref].getInstance().clear();
                            }.bind(this));
                        }}>
                            <FontAwesome name={"trash"}/>
                        </Button></Col>
                </Row>;
            } else {
                /*if (typeof data[counter].collectionId !== 'undefined' && typeof data[counter].items === 'undefined')
                    data[counter].items = TreeUtilities.extractItemsByComposedCollection(data[counter].collectionId, this.state.composedCollections).items;*/
                var preCollectionLabelType = '';
                var postFix = (isBasicItem ? "" : "not") + "basic";
                const collection = TreeUtilities.extractItemsByComposedCollection(data[counter].collectionId, this.props.composedCollections);

                this.props.composedCollections.some((item) => {
                    if (item.id === data[counter].collectionId) {
                        /*data[counter].items = item.items;*/
                        preCollectionLabelType = item.label;
                        selected = [item];
                        return true;
                    }
                });

                itemSelected = typeof data[counter].itemIdSelected === 'undefined' ? [] : [TreeNodeHelper.getAutoCompleteItemById(collection.items, data[counter].itemIdSelected)];
                if (typeof itemSelected[0] === 'undefined') {
                    itemSelected = [];
                } else {
                    var itemLabel = itemSelected[0].label;
                    itemLabel = itemLabel.startsWith('noI18n:') ? itemLabel.replace('noI18n:', '').replace('_', ' ') : Dict.t(itemLabel);
                    itemSelected = [{id: itemSelected[0].id, label: itemLabel}]
                }

                const sortedItems = collection.items.sort(function (a, b) {
                        const aLabel = a.label.startsWith('noI18n:') ? a.label.replace('noI18n:', '').replace('_', ' ') : Dict.t(a.label);
                        const bLabel = b.label.startsWith('noI18n:') ? b.label.replace('noI18n:', '').replace('_', ' ') : Dict.t(b.label);

                        return aLabel > bLabel ? 1 : -1;
                    }
                );

                retElement = <div
                    className={BUtils.joinClasses(stylesSCTree['teb-autocomplete-pre'], stylesSCTree['teb-autocomplete-pre-' + postFix])}>
                    {isBasicItem ? <FormControl
                        id={id}
                        type="text"
                        className={stylesSCTree['teb-autocomplete-add__input-custom-label']}
                        placeholder={'etichetta viewer'}
                        ref={(input) => {
                            this['formControl-autocomplete-' + counter] = input;
                        }}
                        value={data[counter].customLabel}
                        onChange={(evt) => {
                            data[counter].customLabel = evt.target.value;
                            this.setState({data});
                        }}
                        onKeyDown={() => {
                        }}
                    /> : ''}
                    {isBasicItem ? <Typeahead
                        clearButton
                        className={stylesSCTree['teb-pre-autocomplete-collections']}
                        onChange={item => {
                            if (item.length > 0) {
                                /*data[counter].items = item[0].items;*/
                                data[counter].collectionId = item[0].id;
                            } else {
                                /*data[counter].items = [];*/
                                data[counter].collectionId = '';
                                delete data[counter].itemIdSelected;
                            }
                            this.setState({data});
                        }}
                        onSearch={() => {
                            return;
                        }}
                        options={JSON.parse(JSON.stringify(this.state.composedCollections))}
                        placeholder={Dict.t('AVAILABLE_COLLECTIONS')}
                        selected={selected}
                    /> : "" /*<label htmlFor={"th-autocomplete-pre-" + postFix}>({preCollectionLabelType})</label>*/}
                    <Typeahead
                        id={"th-autocomplete-pre-" + postFix}
                        ref={(typeahead) => this[ref] = typeahead}
                        clearButton
                        className={stylesSCTree['teb-pre-autocomplete-selected']}
                        onChange={item => {
                            if (typeof item[0] === 'undefined')
                                delete data[counter].itemIdSelected;
                            else
                                data[counter].itemIdSelected = item[0].id;

                            this.setState({data});
                        }}
                        onSearch={() => {
                            return;
                        }}
                        options={sortedItems.map((item) => {
                            var label = item.label;
                            label = label.startsWith('noI18n:') ? label.replace('noI18n:', '').replace('_', ' ') : Dict.t(label);
                            return {id: item.id, label}
                        })}
                        selected={itemSelected}
                        placeholder={isBasicItem ? Dict.t('COLLECTION') : label}
                    />
                </div>;
            }
        } else if (type === 'dropzone') {

            /*colLeft = 2;
            colRight = 10;*/
            //data[counter].label
            var code = data[counter].code;

            var dropPreviewId = "drop-preview-" + id;
            var resourcePreviewId = "resource-preview-" + id;

            var StoredImages = "";
            var storedCarouselItems = [];
            var toDeleteImages = "";
            var toDeleteCarouselItems = [];
            const carouselCode = data[counter].code;

            if (typeof value !== 'undefined' && value.length > 0) {
                if (!Array.isArray(value)) {
                    value = [value];
                }
                StoredImages = value.map((item, index) => {

                    var src = this._buildSrc(item, data[counter]);
                    const id = "stored-" + counter;

                    if (code === 'DOCUMENTS') {
                        label = TreeNodeHelper.getDocumentCustomLabel(item, data[counter].label, counter, composedItem, this.props.interfaceLang);

                        src = {
                            src: src,
                            filename: item.filename,
                            extension: item.extension,
                            folder: data[counter].folder
                        };
                    }

                    storedCarouselItems.push(src);
                    if (typeof item.status !== 'undefined' && item.status === 'to_remove')
                        toDeleteCarouselItems.push(src);

                    return this._buildComponentSrc(data[counter], src, id, "stored", index);
                });

                toDeleteImages = this.state.toDeleteCarouselItems.map((src, index) => {
                    const id = "toDelete-" + counter;
                    return this._buildComponentSrc(data[counter], src, id, "toDelete", counter);
                });
            } else {
                label = TreeNodeHelper.getDocumentCustomLabel(undefined, data[counter].label, counter, composedItem, this.props.interfaceLang);
            }

            retElement = <div id={id}>
                <Col lg={5} md={5}>
                    <Dropzone accept={this.state.data[counter].accept}
                              acceptClassName="accept-drop-zone"
                              ref={(node) => {
                                  this.dropzoneElement = node;
                              }}
                              className={'area-dropzone' + ' ' + stylesSCTree['dropzone-element']}
                              onDrop={acceptedFiles => {
                                  if (typeof data[counter].preview === 'undefined')
                                      data[counter].preview = [];

                                  //TODO: provvisiorio. al momento si consente un solo audio per galleria(audio)
                                  var previewCarouselItems = null;
                                  if (data[counter].code === 'AUDIO_GALLERY' || data[counter].code === 'DOCUMENTS') {
                                      data[counter].preview = [];
                                      previewCarouselItems = [];
                                  } else {
                                      previewCarouselItems = this.state.previewCarouselItems;
                                  }

                                  data[counter].preview.push(acceptedFiles);
                                  //var previewCarouselItems = this.state.previewCarouselItems;

                                  acceptedFiles.forEach((file, index) => {
                                      if (code === 'DOCUMENTS') {
                                          const dropPreview = document.getElementById(dropPreviewId);
                                          dropPreview.innerHTML = "";
                                          var openViewerDocButtonId = 'doc-accepted-preview-' + (index + dropPreview.children.length);
                                          var a = document.createElement("a");
                                          a.id = openViewerDocButtonId;
                                          a.innerHTML = file.name;
                                          a.className = stylesSCTree['dropzone-document-preview-element'];
                                          a.target = '_blank';
                                          a.onclick = () => {
                                              TreeUtilities.createTmpFileByDatFile(file, file.type).then((result) => {
                                                  var filename = BUtils.extractFilenameNoExtension(file.name);
                                                  var extension = BUtils.extractFileExtension(file.name);
                                                  var encodedFilename = AdministrationUtilities.encodeOSPath(filename);
                                                  var src = BUtils.getServerUrl() + '/tree/getTmpFile/' + encodedFilename + '/' + extension;
                                                  var fileLength = parseInt(result.message);
                                                  this._openDocumentPreview(src, openViewerDocButtonId, fileLength, filename, extension, true, 0, null /*this.props.item.key*/, this.props.item);
                                              });
                                          };

                                          dropPreview.appendChild(a);
                                      } else {
                                          var tag = "";

                                          if (file.type.startsWith("audio")) {
                                              tag = "audio";
                                              var elbt = document.createElement("button");
                                              elbt.innerHTML = "&nbsp;&#9654";
                                              elbt.onclick = function () {
                                                  document.getElementById(file.lastModified).play();
                                              };

                                              //TODO: provvisiorio. al momento si consente un solo audio per galleria(audio)
                                              const dropPreview = document.getElementById(dropPreviewId);
                                              if (data[counter].code === 'AUDIO_GALLERY' && dropPreview.children.length > 1) {
                                                  while (dropPreview.firstChild)
                                                      dropPreview.removeChild(dropPreview.lastChild);
                                              }
                                              dropPreview.appendChild(elbt);


                                          } else if (file.type.startsWith("video")) {
                                              tag = "video";
                                          } else {
                                              tag = "img";
                                          }

                                          var element = document.createElement(tag);
                                          element.src = file.preview;
                                          element.className = stylesSCTree['gallery-element-preview'];
                                          element.id = file.lastModified;
                                          previewCarouselItems.push(file.preview);

                                          document.getElementById(dropPreviewId).appendChild(element);
                                          element.onclick = function () {
                                              var index = Array.from(element.parentNode.children).indexOf(element);
                                              this._openCarouselByIndex('preview', index);
                                          }.bind(this);
                                      }
                                  });

                                  this.setState({
                                      data, previewCarouselItems
                                  });
                              }}
                              onDropRejected={function () {
                              }}>
                        <p>{this.state.data[counter].accept}</p>
                    </Dropzone>
                </Col>
                <Col lg={7} md={7}
                     className={BUtils.joinClasses(stylesSCTree['dropzone-elements-preview'], stylesSCTree['dropzone-elements-preview__' + code])}>
                    <Row
                        className={BUtils.joinClasses(stylesSCTree['row-gallery-buttons'], stylesSCTree['row-gallery-buttons__' + code])}>
                        <Button id="bt-stored-open-gallery" onClick={(evt) => {
                            if (code !== 'DOCUMENTS')
                                this._openEditCarousel('stored', carouselCode, storedCarouselItems, toDeleteCarouselItems, counter);
                        }}>{Dict.t('STORED_FILE_GALLERY')}</Button>
                        <div id={resourcePreviewId}
                             className={stylesSCTree['dropzone-img-container']}>{StoredImages}</div>
                    </Row>
                    <Row
                        className={BUtils.joinClasses(stylesSCTree['row-gallery-buttons'], stylesSCTree['row-gallery-buttons__' + code])}>
                        <Button id="bt-preview-open-gallery" onClick={(evt) => {
                            if (code !== 'DOCUMENTS')
                                this._openEditCarousel('preview', carouselCode, storedCarouselItems, toDeleteCarouselItems, counter);
                        }}>{Dict.t('FILE_PREVIEW_GALLERY')}
                        </Button>
                        <Button onClick={(evt) => {
                            data[counter].preview = [];
                            var dropPreview = document.getElementById(dropPreviewId);
                            while (dropPreview.firstChild) {
                                dropPreview.removeChild(dropPreview.firstChild);
                            }
                            this.setState({
                                previewCarouselItems: []
                            });
                        }}>reset</Button>
                        <div id={dropPreviewId}
                             className={BUtils.joinClasses(stylesSCTree['dropzone-img-container'], stylesSCTree['dropzone-img-container__preview'])}/>
                    </Row>
                    <Row
                        className={BUtils.joinClasses(stylesSCTree['row-gallery-buttons'], stylesSCTree['row-gallery-buttons__' + code])}>
                        <Button id="bt-toDelete-open-gallery" onClick={(evt) => {
                            if (code !== 'DOCUMENTS')
                                this._openEditCarousel('toDelete', carouselCode, storedCarouselItems, toDeleteCarouselItems, counter);
                        }}>{Dict.t('FILE_TO_DELETE_GALLERY')}
                        </Button>
                        <Button onClick={(evt) => {
                            data[counter].value.forEach((dataCounterValueItem) => {
                                delete dataCounterValueItem.status;
                            });
                            this.setState({
                                toDeleteCarouselItems: []
                            });
                        }}>reset</Button>
                        <div id={resourcePreviewId}
                             className={stylesSCTree['dropzone-img-container']}>{toDeleteImages}</div>
                    </Row>
                </Col>
            </div>;
        } else if (type === 'pathbrowser') {
            label = data[counter].label;
            /*var formElementRefId = this['formControl-pathbrowser-' + id];*/
            value = data[counter].value;

            var resetFilesCallback = function (result, isDirectory) {
                data[counter].value = {
                    path: result.folderPath,
                    showContents: !result.forceHideContents && !this.isAdd && this.state.data[counter].value.showContents,
                    isDirectory: isDirectory,
                    filename: result.filename
                };
                this.setState({data, opening: false});

                this._buildPathBrowserView(result, isDirectory, 'pathbrowser-list-files-' + counter);

            }.bind(this);

            if (this.state.opening) {
                if (this.isAdd) {
                    TreeNodeHelper.resetListFiles("", "", true, true, resetFilesCallback);
                } else {
                    TreeNodeHelper.resetListFiles(value.path, "path", true, value.isDirectory, resetFilesCallback);
                }
            }

            retElement = <div>
                <Col lg={9} md={9} className={stylesSCTree['path-browser-rows']}>
                    <Row>
                        <FormControl
                            id={id}
                            type="text"
                            placeholder={''}
                            ref={(input) => {
                                this.formElementRefId = input;
                            }}
                            value={typeof value === 'undefined' ? '' : value.path}
                            onPaste={(evt) => {
                                setTimeout(function () {
                                    this._checkPath(data, counter, resetFilesCallback);
                                }.bind(this), 200);
                            }}
                            onChange={(evt) => {
                                document.getElementById("pathbrowser-error").style.display = 'none';
                                data[counter].value.path = evt.target.value;
                                data[counter].value.found = false;
                                this.setState({data});
                            }}
                            onKeyDown={(evt) => {
                                if (evt.keyCode === 13) {
                                    data[counter].value.path = evt.target.value;
                                    this._checkPath(data, counter, resetFilesCallback);
                                } else {
                                    data[counter].value.found = false;
                                }

                                this.setState({data});
                            }}
                        />
                    </Row>
                    {typeof value === 'undefined' ? '' : <Row
                        className={stylesSCTree['row-chk-show-contents--' + (BUtils.isImage(value.path) || value.isDirectory ? 'show' : 'hide')]}>
                        <SCCheckbox label={Dict.t('SHOW_CONTENTS_IN_FRONTEND')}
                                    id={"chk-show-contents-" + counter}
                                    additionalClass={stylesSCTree['path-browser-rows__sc-checkbox']}
                                    checked={typeof value !== 'undefined' && value.showContents}
                                    callbackParent={(id, newState) => {
                                        data[counter].value.showContents = newState;
                                        this.setState({data});
                                    }}
                        />
                    </Row>}
                    <Row>
                        <div id={'pathbrowser-list-files-' + counter}/>
                    </Row>
                </Col>
                <Col lg={3} md={3} className={stylesSCTree['pathbrowser-col-buttons'] + ' teb-col-pathbrowser-' + type}>
                    <Button className={"teb-button-remove-" + type} onClick={() => {
                        data[counter].value.path = value.path;
                        this._checkPath(data, counter, resetFilesCallback);
                    }}>
                        <FontAwesome name={"arrow-right"}/>
                    </Button>
                    <Button className={"teb-button-remove-" + type} onClick={() => {
                        TreeNodeHelper.resetListFiles(value.path, "previous", true, true, resetFilesCallback);
                    }}>
                        <FontAwesome name={"arrow-up"}/>
                    </Button>
                    <Button className={"teb-button-remove-" + type} onClick={() => {
                        document.getElementById("pathbrowser-error").style.display = 'none';
                        TreeNodeHelper.resetListFiles(value.path, "home", true, true, resetFilesCallback);
                    }}>
                        <FontAwesome name={"home"}/>
                    </Button>
                    <FontAwesome id={"pathbrowser-error"}
                                 className={BUtils.joinClasses(stylesSCTree['pathbrowser-col-buttons__info'], stylesSCTree['pathbrowser-col-buttons__info--' + (!this.isAdd && value.isUrl ? 'warning' : 'error')])}
                                 data-tip data-for={'tooltip-path-not-found'}
                                 name={!this.isAdd && value.isUrl ? "warning" : "exclamation"}/>
                    <ReactTooltip id={'tooltip-path-not-found'} type='info' delayShow={20}
                                  className={"tree-tool-tip"}>{Dict.t(!this.isAdd && value.isUrl ? 'FOUND_URL' : 'PATH_NOT_FOUND')}</ReactTooltip>
                </Col>
            </div>;
        } else if (type === 'treelink') {
            label = data[counter].label;
            //label = this.props.isBasicItem ?  TreeNodeHelper.getBasicItemByCode(data[counter].code).element.label : data[counter].label;
            var selectedValue = typeof data[counter].value === 'undefined' || data[counter].value === '' ? [] : [data[counter].value];

            /*if (selectedValue.length > 0) {
                console.log();
            }*/

            retElement = <div className={stylesSCTree['only-treelink']}>
                <Col lg={7} md={7}>
                    <AsyncTypeahead
                        id={'treelink-typeahead'}
                        isLoading={selectedValue.length === 0}
                        delay={800}
                        ref={"treeitemlinktypeaheadt"}
                        className={stylesSCTree["treelink-typeahead"]}
                        maxResults={5}
                        clearButton
                        onChange={item => {
                            data[counter].value = item.length > 0 ? item[0] : '';
                            this.setState({data});
                        }}
                        onKeyDown={() => {
                            /*var treeLinkOptions = [];
                            this.setState({treeLinkOptions});*/
                        }
                        }
                        onSearch={(textSearch) => {
                            var treeLinkOptions = [];
                            Dict.call('/tree/searchItems/' + this.props.projectName + '/' + textSearch + '/5/' + this.isLogged + '/').then((result) => {
                                result.listItems.forEach((item) => {
                                    var notLoggedHidden = item.hidden;
                                    if (item.code !== 'FOLDER' && !notLoggedHidden) {
                                        var value = item.title;
                                        treeLinkOptions.push({
                                            id: item.key,
                                            label: value,
                                            code: item.code,
                                            isBasic: item.isBasic,
                                            value,
                                        });

                                        this.setState({treeLinkOptions});
                                    }
                                });
                            });
                        }}
                        options={this.state.treeLinkOptions}
                        defaultSelected={selectedValue}
                        placeholder={Dict.t('SEARCH')}
                        useCache={false}
                    /></Col>{selectedValue.length > 0 ?
                <Col lg={5} md={5} style={{paddingTop: '7px', fontWeight: 'bold'}}>
                    <span>{selectedValue[0].isBasic ? Dict.t(selectedValue[0].code) : selectedValue[0].code}</span>
                    <FontAwesome className={stylesSCTree['tree-node-fa']}
                                 name={this.props.itemsToIcon[selectedValue[0].code]}/>
                </Col> : ''}
            </div>;
        } else if (type === 'alignmentDocs') {
            const folder = id.split('-')[0];
            const isChecking = this.state.alignmentInfos.status === 'checking';
            const isActive = this.state.alignmentInfos.isServiceActive;
            const status = value.status;
            const langs = Dict.getGlobalProperty('ALIGNMENT_DICTIONARY_SERVICE_LANGUAGE');
            const langsList = [Dict.t('NONE_F')].concat(langs.split(',')).map((item) => {
                return {value: item, text: item};
            });
            const halfStoredFile1Missing = value.status === 'stored' && typeof value.file2 !== 'undefined';
            const halfStoredFile2Missing = value.status === 'stored' && typeof value.file1 !== 'undefined';

            const nextId = this.props.autoincrement + parseFloat(1);
            const prefix = Dict.getGlobalProperty('ALIGNMENT_DICTIONARY_SERVICE_PREFIX') + (this.isAdd ? nextId : folder) + '_';
            const FieldGroup = ({id, label, help, isStored, isValid, ...props}) => {
                const langId = 'lang' + id.replace('file', '');
                return (
                    <>
                        <FormGroup bsClass={stylesSCTree['tree-node-alignamentinput-group']} controlId={id}>
                            <ControlLabel>{label}</ControlLabel>
                            {isActive && (!isStored || !isValid) ? <FormControl {...props}
                                                                                bsClass={''}
                                                                                onChange={(ev) => {
                                                                                    var file = ev.target.files[0];
                                                                                    TreeUtilities.createTmpFileByDatFile(file, file.type).then((result) => {
                                                                                        const idRepl = id.replace('file', '');
                                                                                        const otherId = idRepl === '1' ? '2' : '1'
                                                                                        var filename = BUtils.extractFilenameNoExtension(file.name);
                                                                                        var extension = BUtils.extractFileExtension(file.name);
                                                                                        //var encodedFilename = AdministrationUtilities.encodeOSPath(filename);
                                                                                        if (data[counter].value === '') {
                                                                                            data[counter].value = {};
                                                                                        }

                                                                                        if (typeof data[counter].value[id] !== 'undefined') {
                                                                                            data[counter].value['old' + idRepl] = data[counter].value[id];
                                                                                        }

                                                                                        data[counter].value[id] = prefix + filename + '.' + extension;
                                                                                        if (typeof value.originalStatus === 'undefined') {
                                                                                            data[counter].value.originalStatus = typeof value.status !== 'undefined' ? value.status : 'to_store';
                                                                                        }

                                                                                        const filenameSplit = filename.split('_');
                                                                                        /*const langSplit = filenameSplit[filenameSplit.length - 1];
                                                                                        var lang = langSplit.split('-');
                                                                                        lang = lang[lang.length - 1];*/
                                                                                        const lang = filenameSplit[filenameSplit.length - 1];

                                                                                        if (lang.length > 0 && langsList.findIndex((item) => {
                                                                                            return item.value === lang;
                                                                                        }) >= 0) {
                                                                                            Notifications.showToastNotification("Rilevata lingua " + lang + " in " + (id.endsWith('1') ? 'entrata' : 'uscita'), 4000, 500);
                                                                                            data[counter].value[langId] = lang;
                                                                                        }

                                                                                        if (typeof data[counter].value['file' + otherId] === 'undefined')
                                                                                            data[counter].value.status = 'to_store' + idRepl;
                                                                                        else if (status === 'stored' + otherId)
                                                                                            data[counter].value.status = status + '_' + 'to_store' + idRepl;
                                                                                        else
                                                                                            data[counter].value.status = status !== 'stored' && (status === 'to_store' || status !== 'to_store' + idRepl) ? 'to_store' : 'to_store' + id.replace('file', '');

                                                                                        this.setState({data}, () => {
                                                                                            const container = document.querySelector('#tree-object-element-container');
                                                                                            container.scrollTop = container.scrollHeight;
                                                                                            this._checkAlignedByLangs(data, counter, nextId);
                                                                                        });
                                                                                    });
                                                                                }}
                            /> : ''}
                            {help && (!isStored || !isValid) &&
                                <HelpBlock>{typeof data[counter].value[id] === 'undefined' ? 'No file selected' : Dict.t('NEW') + ': ' + data[counter].value[id] + '/html'}</HelpBlock>}
                        </FormGroup>
                        {typeof data[counter].value[id] !== 'undefined' && (!isStored || !isValid) ?
                            <SCCombo options={langsList}
                                     value={typeof data[counter].value[langId] === 'undefined' ? langsList[0].value : data[counter].value[langId]}
                                     label={Dict.t('ASSIGN_LANGUAGE')}
                                     callbackParent={(newState) => {
                                         data[counter].value[langId] = newState;
                                         this.setState({data}, () => {
                                             const container = document.querySelector('#tree-object-element-container');
                                             container.scrollTop = container.scrollHeight;
                                             this._checkAlignedByLangs(data, counter, nextId);
                                         });
                                     }}/> : ''}
                    </>
                );
            }

            label = data[counter].label;

            var storedDocs = ['', ''];
            if (value !== '') {
                storedDocs = [1, 2].map((countFile, index) => {
                    if (typeof value['file' + countFile] !== 'undefined' && !status.startsWith('not_valid') && status !== 'to_store' && ((status.indexOf('stored' + countFile) >= 0) || status === 'stored')) {
                        var fileCompleteName = value['file' + countFile];
                        var itemToSend = {
                            filename: BUtils.extractFilenameNoExtension(fileCompleteName),
                            extension: BUtils.extractFileExtension(fileCompleteName)
                        };
                        label = TreeNodeHelper.getDocumentCustomLabel(itemToSend, data[counter].label, counter, composedItem, this.props.interfaceLang);

                        var src = this._buildSrc(itemToSend, {folder});

                        return this._buildComponentViewerSrc(data[counter], {
                            src: src,
                            nDoc: countFile,
                            filename: itemToSend.filename + '.' + itemToSend.extension,
                            folder,
                            projectName: this.props.projectName
                        }, "key-viewer-list-" + index);
                    } else {
                        return '';
                    }
                });
            }

            const buttonBar = <>
                <div className={stylesSCTree['alignment-buttonbar']}>
                    {value !== '' && !value.status.startsWith('stored') ? <Button
                        onClick={() => {
                            if (typeof value.originalStatus !== 'undefined') {
                                data[counter].value.status = value.originalStatus;
                            }

                            if (value.status === 'to_remove') {
                                data[counter].value.status = 'stored';
                            }

                            if (typeof value.old1 !== 'undefined') {
                                data[counter].value.file1 = value.old1;
                                delete data[counter].value.old1;
                            }
                            if (typeof value.old2 !== 'undefined') {
                                data[counter].value.file2 = value.old2;
                                delete data[counter].value.old2;
                            }

                            if (value.originalStatus === 'to_store') {
                                data[counter].value = '';
                            }

                            this.setState({data})
                        }}
                    >{Dict.t('RESET')}</Button> : ''}
                    {value !== '' && value.status === 'not_valid_alignment_found' ? <Button
                        onClick={() => {
                            Dict.call('/tree/alignmentService/deleteAlignedFile/' + this.props.projectName + '/' + this.props.item.key + '/' + LexemeUtilities.encodeUrl(JSON.stringify(value)) + '/').then((result) => {
                                if (result.result === 'OK') {
                                    //Notifications.showToastNotification('ignore:' + result.message, 2000);
                                    this._checkAlignedByLangs(data, counter);
                                }
                                if (result.result === 'error') {
                                    Notifications.showErrorModalMessage('ignore:' + result.message, 2000);
                                }

                            })
                        }}
                    >{Dict.t('REMOVE_CURRENT_ALIGNMENT')}</Button> : ''}
                    {value !== '' && value.status.startsWith('stored') ? <Button onClick={() => {
                        data[counter].value.originalStatus = value.status
                        data[counter].value.status = 'to_remove';
                        this.setState({data});
                    }}>{Dict.t('REMOVE')}</Button> : ''}
                </div>
                {typeof value.file1 !== 'undefined' && value.status === 'stored' ?
                    <div className={stylesSCTree['alignment-status']}>
                        {isChecking || isActive ? <Alert
                            bsStyle={this.state.alignmentInfos.style}>{this.state.alignmentInfos.text}</Alert> : ''}
                        {!isChecking && !isActive ?
                            <Alert bsStyle={this.state.alignmentInfos.style}>Server di allineamento non
                                attivo</Alert> : ''}
                        {isActive && this.state.alignmentInfos.status === 'not_aligned' ? <Button
                            onClick={() => {
                                Dict.call('/tree/alignmentService/alignSendFile/' + this.props.projectName + '/' + this.props.item.key + '/' + LexemeUtilities.encodeUrl(JSON.stringify(value)) + '/').then((result) => {
                                    if (result.result === 'error')
                                        Notifications.showErrorModalMessage('ignore:' + result.message, 2000);
                                })
                            }}
                        >{Dict.t('ALIGN')}</Button> : ''}
                        {!isChecking && !isActive ? <Button
                            onClick={() => {
                                var alignmentInfos = this.state.alignmentInfos;
                                alignmentInfos.status = 'checking';
                                alignmentInfos.style = 'warning';
                                alignmentInfos.text = Dict.t('CHECKING_ALIGMENT');
                                this.setState({alignmentInfos}, () => {
                                    this._checkAligned(true);
                                })
                            }}
                        >Verifica</Button> : ''}
                    </div> : ''}
            </>

            const remove = <div
                className={stylesSCTree['alignment-remove']}>{Dict.t('MSG_REMOVING_ALIGNMENT_NEXT_SAVE')}</div>

            retElement = <>
                {value.status !== 'to_remove' ? <>
                    <FieldGroup
                        id="file1"
                        type="file"
                        label=/*"File 1"*/ {'File ' + Dict.getGlobalProperty('ALIGNMENT_TEXT_SEARCH_LABEL_1')}
                        help="Example block-level help text here."
                        isStored={(typeof status !== 'undefined' && status !== 'to_store') && (status.indexOf('stored1') >= 0 || status === 'stored')}
                        isValid={typeof status !== 'undefined' && !status.startsWith('not_valid')}
                    />{storedDocs[0]}
                    <FieldGroup
                        id="file2"
                        type="file"
                        label=/*"File 2"*/ {'File ' + Dict.getGlobalProperty('ALIGNMENT_TEXT_SEARCH_LABEL_2')}
                        help="Example block-level help text here."
                        isStored={(typeof status !== 'undefined' && status !== 'to_store') && (status.indexOf('stored2') >= 0 || status === 'stored')}
                        isValid={typeof status !== 'undefined' && !status.startsWith('not_valid')}
                    />{storedDocs[1]}
                </> : ''}
                {value.status === 'to_remove' ? remove : ''}
                {buttonBar}
            </>

        }

        if (this.props.isBasicItem) {
            label = Dict.t(label);
        }

        return <div
            className={BUtils.joinClasses(stylesSCTree['tree-object-wrapper']/*, stylesSCTree['tree-object-wrapper--' + (isHidden ? 'hide' : 'show')]*/)}>
            <Col lg={colLeft} md={colLeft} className={additionalColLeft}>
                {isBasicItemHidden && false ?
                    <FontAwesome name={'eye-slash'} data-tip data-for={'tooltip-basicItem-hidden-' + counter}
                                 className={stylesSCTree['tree-object-wrapper__show-hidden-basicItem-fa']}/> :
                    <Button onClick={() => {
                        data[counter].hidden = !isHidden;
                        this.setState({data});
                    }} className={stylesSCTree['tree-object-wrapper__show-hide-button']}>
                        <FontAwesome name={isHidden ? 'eye-slash' : 'eye'} data-tip
                                     data-for={'tooltip-bt-hide-show-' + counter}
                                     className={stylesSCTree['tree-object-wrapper__show-hide-button-fa']}/>
                    </Button>}
                <label
                    className={stylesSCTree['tree-object-wrapper__label']}>
                    {label}</label>
                <ReactTooltip id={'tooltip-bt-hide-show-' + counter} type='info' delayShow={250}
                              className={"tree-tool-tip"}>{Dict.t('BT_HIDE_SHOW_TREE_OBJECT_TOOLTIP')}</ReactTooltip>
                <ReactTooltip id={'tooltip-basicItem-hidden-' + counter} type='info' delayShow={250}
                              className={"tree-tool-tip"}>{Dict.t('BASIC_ITEM_TREE_OBJECT_HIDDEN_TOOLTIP')}</ReactTooltip>
            </Col>
            <Col
                lg={colRight} md={colRight}
                className={BUtils.joinClasses(additionalColRight, stylesSCTree['tree-object-wrapper__col-right--' + (isHidden || isBasicItemHidden ? 'hide' : 'show')])}>{retElement}</Col>
        </div>;
    }

    _checkAlignedByLangs(data, counter, prefix) {
        var value = data[counter].value;
        const idToCheck = typeof prefix !== 'undefined' ? prefix : this.props.item.key;
        if (typeof value.lang1 !== 'undefined' && typeof value.lang2 !== 'undefined') {
            Dict.call('/tree/alignmentService/checkAlignedPahtByLangs/' + this.props.projectName + '/' + idToCheck + '/' + LexemeUtilities.encodeUrl(JSON.stringify(value)) + '/').then((result) => {
                setTimeout(() => {
                    var okMsg = '';
                    if (result.result === 'OK') {
                        value.status = value.originalStatus;
                        //Notifications.showToastNotification(result.message, 2000, 0);
                        okMsg = result.message;
                    } else {
                        value.status = 'not_valid';
                        Notifications.showErrorModalMessage('ignore:' + result.message, 3000);
                    }

                    this.setState({data}, () => {
                        Dict.call('/tree/alignmentService/isAligned/' + this.props.projectName + '/' + prefix + '/').then((result) => {
                            if (result.result === 'OK') {
                                value.status = 'not_valid_alignment_found';
                                Notifications.showErrorModalMessage('ignore:' + result.message, 3000)
                                this.setState({data});
                                /*value.status = value.originalStatus;
                                Notifications.showWarningToastNotification(result.message, 20000, 0);*/
                            } else {
                                Notifications.showToastNotification(okMsg, 2000, 0);
                            }
                        })
                    });
                }, 1000)
            })
        }
    }


    _checkPath(data, counter, callback) {
        var path = data[counter].value.path;
        this.setState({data}, function () {
            var encodedFolderPath = LexemeUtilities.encodeUrl(AdministrationUtilities.encodeOSPath(path));
            var isUrl = BUtils.isUrl(path);
            if (isUrl) {
                data[counter].value.found = true;
                data[counter].value.isDirectory = false;
                data[counter].value.isUrl = true;
                data[counter].value.path = path;
                document.getElementById("pathbrowser-error").style.display = 'inline';

                this.setState({data});
            } else {
                data[counter].value.isUrl = false;
                Dict.call('/tree/checkIsDirectory/' + encodedFolderPath + '/').then(result => {
                    if (result.exists) {
                        TreeNodeHelper.resetListFiles(path, "path", true, result.isDirectory, callback);
                        data[counter].value.found = true;
                        this.setState({data});
                    } else {
                        document.getElementById("pathbrowser-error").style.display = 'inline';
                        data[counter].value.found = false;
                    }
                });
            }
        });
    }

    // VIEWER ELEMENTO
    _retrieveElementViewer(id, counter, isBasicItemHidden) {
        var data = this.state.data;
        const type = data[counter].type;
        var value = data[counter].value;
        const composedItem = TreeNodeHelper.getItemByCode(this.props.item.code, this.props.composedTreeItems);

        var retElement = '';
        var colLeft = 3;
        var colRight = 9;
        var label = data[counter].label;
        const isHidden = data[counter].hidden === true;
        //const isBasicItemHidden = data[counter].basicItemHidden;

        if (type === "textfield") {
            retElement = <Row className={stylesSCTree['tree-object-viewer__tinymce']}>{value}</Row>;
        } else if (type === "weblink") {
            if (!value.startsWith('http') && value !== "")
                value = 'http://' + value;
            retElement = <MicrolinkCard url={value}/>;
        } else if (type === "tinymce") {
            retElement = <Row className={stylesSCTree['tree-object-viewer__tinymce']}
                              dangerouslySetInnerHTML={{__html: value}}/>;
        } else if (type === "datepicker") {
            /*colLeft = 2;
            colRight = 10;*/
            while (value.length < 4)
                value = "0".concat(value);

            retElement = <Row
                className={stylesSCTree['tree-object-viewer__datepicker']}>{TreeUtilities.writeDateString(new Date(value), data[counter].choosenMode)}</Row>;
        } else if (type === "checkbox") {
            /*colLeft = 4;
            colRight = 8;*/
            retElement = <Row>
                <span
                    className={BUtils.joinClasses(stylesSCTree['tree-object-viewer__checkmark'], stylesSCTree['tree-object-viewer__checkmark--' + (value ? 'checked' : 'unchecked')])}/>
            </Row>;
        } else if (type === "dropzone" /*|| type === "pdf-page-number"*/) {
            //const isPdfPage = false//true || type === "pdf-page-number";
            //TODO: credo sia giusto mettere code e non label, in ottica oggetti composti. Da testare
            const isCarousel = (label !== 'AUDIO_GALLERY' && data[counter].code !== 'AUDIO_GALLERY') && label !== 'VIDEO_GALLERY' && label !== 'DOCUMENT';
            const isDocument = label === 'DOCUMENT' || data[counter].code === 'DOCUMENTS' || isPdfPage;

            /*if (isPdfPage)
                label = Dict.t(label) + " pag." + value;*/


            if (!Array.isArray(value)) {
                value = [value];
            }

            if (isDocument) {
                const folder = /*isPdfPage ? NodeOperations.retrieveParentKey(this.state.item) : */data[counter].folder;
                const StoredDocs = value.map((item, index) => {
                    var dataToSend = {folder};
                    var itemToSend = /*isPdfPage ? data[counter].resource :*/ item;
                    label = TreeNodeHelper.getDocumentCustomLabel(itemToSend, data[counter].label, counter, composedItem, this.props.interfaceLang);

                    const src = this._buildSrc(itemToSend, dataToSend);
                    return this._buildComponentViewerSrc(data[counter], {
                        src: src,
                        filename: itemToSend.filename + '.' + itemToSend.extension,
                        folder,
                        projectName: this.props.projectName
                    }, "key-viewer-list-" + index);
                });

                retElement =
                    <div id={"tree-docs-viewer"} className={stylesSCTree['tree-docs-viewer']}>{StoredDocs}</div>
            } else {

                const StoredImages = value.map((item, index) => {
                    const src = this._buildSrc(item, data[counter]);
                    return this._buildComponentViewerSrc(data[counter], src, "key-viewer-list-" + index);
                });

                if (isCarousel) {
                    var imgGalleryLength = typeof value === 'undefined' ? 0 : value.length;

                    var zoom = typeof data[counter].zoom === 'undefined' ? 'zoom-out' : data[counter].zoom;

                    retElement = <div id={"tree-carousel-drop-container"}
                                      onClick={(evt) => {
                                          var tagName = evt.target.tagName.toLowerCase();
                                          if (tagName === 'div' || tagName === 'img') {
                                              data[counter].zoom = typeof data[counter].zoom === 'undefined' || data[counter].zoom === 'zoom-out' ? 'zoom-in' : 'zoom-out';
                                              this.setState(this.state);
                                          }
                                      }}
                                      className={BUtils.joinClasses(stylesSCTree["tree-carousel-drop-container-viewer"], stylesSCTree["tree-carousel-drop-container-viewer--" + zoom])}>
                        <Carousel
                            id={"tree-carousel-drop"} className={BUtils.joinClasses(stylesSCTree['tree-carousel-drop'])}
                            slide={true}
                            interval={null} indicators={imgGalleryLength > 1} controls={imgGalleryLength > 1}>
                            {StoredImages}
                        </Carousel></div>
                } else {
                    retElement =
                        <div id={"tree-playlist-drop"}
                             className={stylesSCTree['tree-playlist-drop']}>{StoredImages}</div>;
                }
            }
        } else if (type === 'alignmentDocs') {
            const folder = id.split('-')[0];
            const StoredDocs = [1, 2].map((countFile, index) => {
                var fileCompleteName = value['file' + countFile];
                if (typeof fileCompleteName !== 'undefined') {
                    var itemToSend = {
                        filename: BUtils.extractFilenameNoExtension(fileCompleteName),
                        extension: BUtils.extractFileExtension(fileCompleteName)
                    };
                    label = TreeNodeHelper.getDocumentCustomLabel(itemToSend, data[counter].label, counter, composedItem, this.props.interfaceLang);

                    var src = this._buildSrc(itemToSend, {folder});

                    return this._buildComponentViewerSrc(data[counter], {
                        src: src,
                        nDoc: countFile,
                        filename: itemToSend.filename + '.' + itemToSend.extension,
                        folder,
                        projectName: this.props.projectName
                    }, "key-viewer-list-" + index);
                } else
                    return '';
            });

            retElement =
                <div id={"tree-docs-viewer"} className={stylesSCTree['tree-docs-viewer']}>{StoredDocs}</div>
        } else if (type === 'autocomplete') {
            const isCustom = data[counter].code === 'CUSTOM_DATA_COLLECTION';
            const collection = TreeUtilities.extractItemsByComposedCollection(data[counter].collectionId, this.props.composedCollections);

            label = this.state.isBasicItem || isCustom ? data[counter].customLabel : data[counter].label;
            var additionalClass = '';
            var item = TreeNodeHelper.getAutoCompleteItemById(collection.items, data[counter].itemIdSelected)
            if (typeof item === 'undefined') {
                value = Dict.t('NO_ELEMENT_IS_SELECTED') + ".";
                additionalClass = stylesSCTree['tree-object-viewer__autocomplete-viewer-no-element'];
            } else {
                var itemLabel = item.label;
                itemLabel = itemLabel.startsWith('noI18n:') ? itemLabel.replace('noI18n:', '').replace('_', ' ') : Dict.t(itemLabel);
                value = itemLabel;
            }

            retElement = <Row
                className={BUtils.joinClasses(stylesSCTree['tree-object-viewer__autocomplete-viewer'], additionalClass)}>{value}</Row>;
        } else if (type === "pathbrowser") {
            /*colLeft = 4;
            colRight = 8;*/

            var isUrl = BUtils.isUrl(value.path);
            var isLocalDirectory = !isUrl && (typeof value.found === 'undefined' || value.found ? value.isDirectory : !BUtils.isFileByStringPath(value.path, isUrl));
            var isUrlFile = isUrl && !isLocalDirectory;

            if (typeof value.showContents !== 'undefined' && value.showContents) {
                TreeNodeHelper.resetListFiles(value.path, "path", false, isLocalDirectory, function (result) {
                    this._buildPathBrowserView(result, isLocalDirectory, 'viewer-pathbrowser-list-files-' + counter);
                }.bind(this));
            }

            const hideContentsNoDir = !value.showContents && !isLocalDirectory;
            const hideContentsDir = !value.showContents && isLocalDirectory;


            retElement = <div>
                <Row /*onClick={() => {
                    if (hideContentsNoDir)
                        TreeNodeHelper.downloadFile(value.path, value.filename);
                }}*/
                    className={BUtils.joinClasses(stylesSCTree['tree-object-viewer__pathbrowser-textfield'], stylesSCTree['tree-object-viewer__pathbrowser-textfield--show']) /*{+ '--' + (hideContentsDir ? 'show' : 'download')])}*/}>{value.path}</Row>
                <Row className={BUtils.joinClasses(stylesSCTree['tree-object-viewer__pathbrowser-buttons'])}>
                    {hideContentsDir || !isLocalDirectory ? <Button onClick={() => {
                        const el = document.createElement('textarea');
                        el.value = value.path;
                        document.body.appendChild(el);
                        el.select();
                        document.execCommand('copy');
                        document.body.removeChild(el);
                        Notifications.showToastNotification(Dict.t('TOAST_MSG_COPY_PATH_DONE'), 2000, 0);
                    }
                    }>{Dict.t('COPY_PATH')}</Button> : <div id={"viewer-pathbrowser-list-files-" + counter}/>}
                    {isUrlFile ?
                        <Button onClick={() => {
                            var win = window.open(value.path, '_blank');
                            win.focus();
                        }}>{Dict.t('OPEN_NEW_TAB')}</Button>
                        : ''}
                    {/*hideContentsNoDir && !isUrl ?
                        <Button onClick={() => {
                            TreeNodeHelper.downloadFile(value.path, value.filename);
                        }}>{Dict.t('DOWNLOAD_FILE')}</Button>
                        : ''*/}
                </Row>
            </div>;
        } else if (type === 'treelink') {
            if (this.state.isBasicItem)
                label = TreeNodeHelper.getBasicItemByCode(data[counter].code).element.label;
            const hasValue = typeof value !== 'undefined' && Object.keys(value).length > 0;
            var valueLabel = hasValue ? value.value : Dict.t('TREELINK_UNSET');

            var span = <span style={{fontWeight: 'bold', fontSize: '14px'}}>{valueLabel}</span>;
            var fontAwesome = hasValue ?
                <><FontAwesome name={this.props.itemsToIcon[value.code]} data-tip
                               data-for={'tooltip-treelink-' + counter}
                               style={{verticalAlign: 'top', paddingLeft: '3px', paddingRight: '3px'}}/>
                </> : '';
            var reactTooltip = hasValue ? <ReactTooltip id={'tooltip-treelink-' + counter} type='info'
                                                        className={"tree-tool-tip"}>
                {valueLabel}
                <div>{'[' + value.code + ']'}</div>
            </ReactTooltip> : '';

            //NodeOperations.traverseToKeyLoadData(this.props.projectName, this.props.treeStructure, value.id);


            retElement = <div className={stylesSCTree["treelink-viewer"]}>
                <Col lg={8} md={8}
                     className={stylesSCTree["treelink-viewer__label"]}>{span}</Col>
                <Col lg={1} md={1} style={{
                    marginRight: '0px',
                    marginLeft: '0px',
                    padding: '3px',
                    fontSize: '20px'
                }}>{fontAwesome}{reactTooltip}</Col>
                <Col lg={3} md={3} className={BUtils.joinClasses(stylesSCTree['treelink-viewer__button'])}>
                    {hasValue ? <Button bsStyle={'primary'} onClick={(event) => {
                        //NodeOperations.traverseToKeyLoadData(this.props.projectName, this.props.treeStructure, value.id, () => {
                        this.props.callbackOpenTreeLinks(event, value.id)
                        //});
                    }
                    }>{Dict.t('SHOW') + " >>>"}</Button> : ''}
                </Col>
            </div>;

        }

        if ((this.props.isBasicItem) && typeof data[counter].customLabel === 'undefined') {
            label = Dict.t(label);
        }

        return <div className={stylesSCTree['tree-object-wrapper-viewer']}>
            <Col lg={colLeft} md={colLeft}>
                {isBasicItemHidden ?
                    <FontAwesome name={'eye-slash'} data-tip data-for={'tooltip-basicItem-hidden-' + counter}
                                 className={stylesSCTree['tree-object-wrapper__show-hidden-basicItem-fa']}/> : ''}
                <ReactTooltip id={'tooltip-bt-hide-show-' + counter} type='info' delayShow={250}
                              className={"tree-tool-tip"}>{Dict.t('BT_HIDE_SHOW_TREE_OBJECT_TOOLTIP')}</ReactTooltip>
                <ReactTooltip id={'tooltip-basicItem-hidden-' + counter} type='info' delayShow={250}
                              className={"tree-tool-tip"}>{Dict.t('BASIC_ITEM_TREE_OBJECT_HIDDEN_TOOLTIP')}</ReactTooltip>
                <label>{label}</label>
            </Col>
            <Col
                lg={colRight} md={colRight}
                className={stylesSCTree['tree-object-wrapper__col-right--' + (isHidden || isBasicItemHidden ? 'hide' : 'show')]}>{retElement}</Col>
        </div>;
    }

    _buildSrc(item, data) {
        var url2 = TreeUtilities.buildMultimediaSrc(this.props.projectName, item, data);
        return url2;
    }

    _buildComponentSrc(dataCounter, src, id, galleryType, activeIndex) {
        var component;
        const key = 'key-stored-component-' + id;

        var openCarousel = function (_this) {
            _this._openCarouselByIndex(galleryType, activeIndex)
        };

        if (dataCounter.code === "AUDIO_GALLERY") {
            component = <span key={key}>
        <button onClick={(evt) => {
            document.getElementById(id).play();
        }}> ▶</button>
        <audio id={id} src={src}/>
        </span>;
        } else if (dataCounter.code === "VIDEO_GALLERY") {
            component = <video key={key} className={stylesSCTree['gallery-element-preview']} src={src}/>;
        } else if (dataCounter.code === "IMAGE_GALLERY") {
            component = <img key={key} className={stylesSCTree['gallery-element-preview']}
                             onClick={() => openCarousel(this)} src={src}/>;
        } else if (dataCounter.code === 'DOCUMENTS') {
            const containerViewerDocButtonId = 'div-container-open-viewer-doc-' + galleryType + '-' + id;
            const openViewerDocButtonId = 'open-viewer-doc-' + id;
            const filenameToLink = dataCounter.value[0].filename + '.' + dataCounter.value[0].extension;
            const isPdf = dataCounter.value[0].extension.startsWith('pdf');
            component = galleryType !== 'toDelete' || typeof dataCounter.value[0].status !== 'undefined' ?
                <div id={containerViewerDocButtonId} className={stylesSCTree['dropzone-document-elements']}>
                    <div><a id={openViewerDocButtonId} onClick={() => {
                        if (isPdf) {
                            const pdfUrl = src.src; // oppure il link corretto al PDF
                            window.open(pdfUrl, "_blank");
                        } else {
                            this._createEditDocumentOnClick(src.src, openViewerDocButtonId, dataCounter.value[0], 0, src.folder, dataCounter.label);
                        }
                    }}>{filenameToLink}</a></div>
                    {galleryType === 'toDelete' ? '' : <div onClick={() => {
                        var toDeleteCarouselItems = this.state.toDeleteCarouselItems;
                        toDeleteCarouselItems.push(src.src);
                        dataCounter.value[activeIndex].status = "to_remove";

                        this.setState({
                            toDeleteCarouselItems
                        })
                    }
                    }>x</div>}
                </div> : '';
        }

        return component;
    }

    _buildComponentViewerSrc(dataCounter, src, key) {
        var component;
        if (dataCounter.label === "AUDIO_GALLERY" || dataCounter.code === 'AUDIO_GALLERY') {
            component = <audio key={key} src={src} className="tree-playlist-audio-item" controls="controls"/>;
        } else if (dataCounter.label === "VIDEO_GALLERY") {
            component = <video key={key} src={src} className="tree-playlist-audio-item" controls="controls"/>;
        } else if (dataCounter.label === "DOCUMENT" || dataCounter.code === 'DOCUMENTS' || dataCounter.type === "pdf-page-number") {
            /*<Document file={src} ><Page pageNumber={1} /></Document><p>Pbaddi</p>*/
            const openViewerDocButtonId = 'open-viewer-doc-' + key;
            const isPdf = dataCounter.value[0].extension.startsWith('pdf');
            const isDocFile = dataCounter.value[0].extension.startsWith('doc');

            component = <div key={key} className={stylesSCTree['tree-docs-viewer-item']}>
                {dataCounter.type !== 'dropzone' ? <div
                    className={stylesSCTree['tree-docs-viewer-item__name']}>{dataCounter.value}</div> : ''}
                <div className={stylesSCTree['tree-docs-viewer-item__buttons']}>
                    <Button id={openViewerDocButtonId}
                            onClick={() => {
                                if (isPdf) {
                                    const pdfUrl = src.src; // oppure il link corretto al PDF
                                    window.open(pdfUrl, "_blank");
                                } else {
                                    this._createEditDocumentOnClick(src.src, openViewerDocButtonId, isPdf ? dataCounter.resource : dataCounter.value[0], isPdf ? dataCounter.value : "0", src.folder, dataCounter.label);
                                }
                            }}>{Dict.t('SHOW') + (isDocFile ? ' html' : '')}</Button>
                    {/*isPdf ? '' :*/ <Button
                        onClick={() => {
                            TreeNodeHelper.downloadMediaFile(src.projectName, src.filename, src.folder, dataCounter.value[0].extension);
                        }
                        }>{'download' + (isDocFile ? ' doc' : '')}
                    </Button>}
                </div>
            </div>;
        } else if (dataCounter.code === 'ALIGNMENT_DOCS') {
            const openViewerDocButtonId = 'open-viewer-doc-' + key;
            var fileCompleteName = src.filename;
            var item = {
                filename: BUtils.extractFilenameNoExtension(fileCompleteName),
                extension: BUtils.extractFileExtension(fileCompleteName),
                langCode: dataCounter.value['lang' + src.nDoc],
                lang1: dataCounter.value['lang1'],
                lang2: dataCounter.value['lang2']
            };
            const alignmentButton = <div>
                <Button id={openViewerDocButtonId}
                        onClick={() => {
                            this._createEditDocumentOnClick(src.src, openViewerDocButtonId, item, "0", src.folder, 'testo_' + src.nDoc + '___');
                        }}>{Dict.t('SHOW') + ' html'}</Button>
                <Button
                    onClick={() => {
                        TreeNodeHelper.downloadMediaFile(src.projectName, src.filename, src.folder, item.extension);
                    }
                    }>{'download'/*Dict.t('DOWNLOAD') + ' doc'*/}
                </Button>
            </div>;

            component = <div key={key} className={stylesSCTree['tree-docs-viewer-item']}>
                <div title={src.filename.length >= 62 ? src.filename : ''}
                     className={stylesSCTree['tree-docs-viewer-item__name']}>{src.filename}</div>
                <div
                    className={stylesSCTree['tree-docs-viewer-item__langs']}>{dataCounter.value['lang' + src.nDoc]}</div>
                <div className={stylesSCTree['tree-docs-viewer-item__buttons']}>
                    {alignmentButton}
                </div>
            </div>;
        } else {
            component = <CarouselItem key={key}>
                <div className={stylesSCTree['tree-object-viewer__carousel-container']}>
                    <img className={stylesSCTree['tree-object-viewer__carousel-container-img']} src={src}
                         alt={'no img'}/>
                </div>
            </CarouselItem>;
        }

        return component;
    }

    _buildPathBrowserView(result, isDirectory, containerId) {
        const folderPath = result.folderPath + '';
        const isImage = BUtils.isImage(folderPath);
        var has;
        if (isDirectory) {
            has = 'files';
        } else if (isImage) {
            has = 'resource';
        } else {
            has = 'no-resource';
        }

        const classeName = BUtils.joinClasses(stylesSCTree['ul-pathbrowser-list-files'], stylesSCTree['ul-pathbrowser-list-files--has-' + has])

        const renderPathBrowserElement = isDirectory ? <ul
                className={classeName}>{result.listFiles}</ul> :
            <div className={classeName}>
                {isImage ? <img className={stylesSCTree['ul-pathbrowser-img']}
                                src={result.resource}/> : ''}
            </div>;

        ReactDOM.render(renderPathBrowserElement, document.getElementById(containerId));
    }

    _createEditDocumentOnClick(src, openViewerDocButtonId, item, page, folder, label) {
        var sizeCall = '/tree/getMultimediaSize/' + src.split('/getMultimedia/')[1];

        Dict.call(sizeCall).then((fileSize) => {
            const filename = item.filename;
            const extension = item.extension;
            const langCode = item.langCode;
            const lang1 = item.lang1;
            const lang2 = item.lang2;
            this._openDocumentPreview(src, openViewerDocButtonId, fileSize, filename, extension, false, page, folder, label, langCode, lang1, lang2);
        });
    }


    _openDocumentPreview(src, buttonId, fileLength, filename, extension, isTmp, page, folder, label, langCode, lang1, lang2) {
        this.setState({
            showDocModal: true,
            doc: {filename: filename, extension: extension, label: label, langCode, lang1, lang2}
        }, () => {
            const parentItem = {projectName: this.props.projectName, key: folder};

            return TreeDOMHelper.openDocumentPreview(src, buttonId, fileLength, parentItem, filename, extension, page, label).then(() => {
                const originalHtml = document.getElementById('scrollable-document-container').innerHTML;
                this.setState({originalHtml})
            });
        });
    }

    _openEditCarousel(showTreeCarousel, carouselCode, storedCarouselItems, toDeleteCarouselItems, carouselPosition) {
        this.setState({
            showTreeCarousel,
            carouselCode,
            storedCarouselItems,
            toDeleteCarouselItems,
            carouselPosition
        });
    }

    _openCarouselByIndex(galleryType, activeIndex) {
        this.setState({activeIndex}, function () {
            document.getElementById("bt-" + galleryType + "-open-gallery").click();
        })
    };

    _handleTitle(evt) {

        var children = '';

        if (this.isAdd) {
            children = typeof this.props.item.children === 'undefined' ? [] : this.props.item.children;
        } else {
            if (TreeNodeHelper.isRootItem(this.props.item)) {
                children = this.props.treeStructure;
            } else {
                children = this.parent.children;
            }
        }

        const hasNodeExistsAnomaly = typeof children !== 'undefined' && children.some((item) => {
            return item !== this.props.item && item.title === evt.target.value;
        });


        var anomaly = {hasAnomaly: false, type: ''};
        if (hasNodeExistsAnomaly) {
            anomaly = {hasAnomaly: true, type: 'NODE_EXISTS_BY_TITLE'}
        } else if (evt.target.value === '') {
            anomaly = {hasAnomaly: true, type: 'TITLE_CANNOT_BE_EMPTY'}
        }

        this.setState({title: evt.target.value, anomaly})
    }

    _saveResource(item) {
        const oldTreeStructure = [...this.state.treeStructure];
        var data = this.state.data;
        var title = this.state.title;
        var id = this.isAdd && !isNaN(this.props.autoincrement) ? this.props.autoincrement + parseFloat(1) : item.key;
        var alignmentOk = 'OK';
        var alignmentToStore = false;
        var alignmentPosition = -1;

        if (this.state.hasAlignment) {
            alignmentPosition = data.findIndex((item) => {
                return item.code === 'ALIGNMENT_DOCS';
            });

            const alignmentValue = data[alignmentPosition].value;
            alignmentToStore = typeof data[alignmentPosition].value.status !== 'undefined' && data[alignmentPosition].value.status !== 'stored';

            if (alignmentToStore) {
                if (alignmentValue.lang1 === alignmentValue.lang2)
                    alignmentOk = 'ALIGNMENT_LANG_ANOMALY';
                else if (alignmentValue.status.startsWith('not_valid'))
                    alignmentOk = 'ALIGNMENT_NOT_VALID';

                const onlyOneFile = typeof alignmentValue.file1 === 'undefined' || typeof alignmentValue.file2 === 'undefined';

                /*if (typeof alignmentValue.file1 === 'undefined' || typeof alignmentValue.file2 === 'undefined')
                    alignmentOk = 'NOT_COMPLETE';
                else */
                if (!onlyOneFile && (typeof alignmentValue.lang1 === 'undefined' || typeof alignmentValue.lang2 === 'undefined'))
                    alignmentOk = 'ALIGNMENT_NOT_VALID';
                else if (!onlyOneFile && (BUtils.extractFileExtension(alignmentValue.file1) !== BUtils.extractFileExtension(alignmentValue.file2)))
                    alignmentOk = 'ALIGNMENT_HAS_DIFFERENT_FILE_TYPE';
            }
        }

        if (title.trim().length > 0 && (alignmentOk === 'OK' || alignmentOk === 'NOT_COMPLETE')) {
            if ((this.state.resourceElementsPosition).length > 0) {
                var buttonSave = document.getElementById('add-element-buttonsave');
                var serviceResults = [];
                /*//TODO: un problema di modali, menu e maschera di editor. Chiusura preventiva per non lasciarne uno appeso. "Risolto" col timeout sottostante
                //Notifications.closeModalSpinner();*/
                Notifications.showModalSpinner(Dict.t("UPLOADING_FILE"), stylesSCTree['modal-doc-convert-message']);
                this._calladdNewOrSetResourceElement(this.state.resourceElementsPosition.length, 0, buttonSave, oldTreeStructure, item, data, id, title, serviceResults);
            }

            //TODO:timeout necessario per non lasciare appeso il modal spinner di upload
            setTimeout(() => {
                    if (this.state.hasAlignment) {
                        if (alignmentToStore) {
                            Notifications.showModalSpinner(Dict.t("TREE_CONVERT_TRANSFERT_DOC_MSG"), stylesSCTree['modal-doc-convert-message']);
                            NodeOperations.addNewOrSetAlignmentDocs(this.props.projectName, oldTreeStructure, item, data, this.isAdd, id, alignmentPosition, (result) => {
                                if (result.result === 'OK') {
                                    const dataValue = data[alignmentPosition].value;
                                    const isHalfStore = typeof dataValue.file1 === 'undefined' || typeof dataValue.file2 === 'undefined';
                                    const storedStatusType = alignmentOk === 'OK' && !isHalfStore ? 'stored' : 'stored' + data[alignmentPosition].value.status.replace('to_store', '');
                                    data[alignmentPosition].value.status = data[alignmentPosition].value.status !== 'to_remove' ? storedStatusType : 'to_remove';
                                    if (data[alignmentPosition].value.status === 'to_remove') {
                                        data[alignmentPosition].value = '';
                                    } else {
                                        delete data[alignmentPosition].value.old1;
                                        delete data[alignmentPosition].value.old2;
                                        delete data[alignmentPosition].value.originalStatus;
                                    }

                                    this._performWaitSyncResource(item, data);
                                } else {
                                    Notifications.closeModalSpinner();
                                    //console.log(result.message);
                                    setTimeout(() => {
                                        Notifications.showErrorModalMessage('ignore:' + result.message, 4000);
                                        //Notifications.showErrorToastNotification("Verifica che una coppia con prefisso " + result.filename + " non sia già allineata ed i file siano .docx non vuoti ", 6000, 3000)
                                    }, 1000);
                                }
                            });
                        } else {
                            const value = data[this.state.resourceElementsPosition].value;
                            if (value.length > 0 && value[0].status === 'to_remove') {
                                data[this.state.resourceElementsPosition].value = [];
                            }
                            this._performWaitSyncResource(item, data);
                        }
                    }
                },
                0);
        } else {
            if (title.trim().length === 0)
                Notifications.showErrorModalMessage('TITLE_CANNOT_BE_EMPTY', 2000);
            else
                Notifications.showErrorModalMessage(alignmentOk, 3000);
        }
    }

    _performWaitSyncResource(item, data) {
        this._waitSyncResource(data, 10, () => {
            Notifications.closeModalSpinner();
            this._save(item);
        })
    }

    _waitSyncResource(data, attempts, callback) {
        const waitingServices = this.state.resourceElementsPosition.filter((position) => {
            return typeof data[position].preview !== 'undefined';
        });
        if (waitingServices.length > 0 || attempts === 0) {
            setTimeout(() => {
                this._waitSyncResource(data, attempts - 1, callback);
            }, 250);
        } else {
            callback();
        }
    }

    _calladdNewOrSetResourceElement(size, position, buttonSave, oldTreeStructure, item, data, id, title, serviceResults) {
        NodeOperations.addNewOrSetResourceElement(this.props.projectName, oldTreeStructure, item, data, id, this.isAdd, this.state.resourceElementsPosition[position], title, function (dataResource, addFile, serviceResult) {
            data[this.state.resourceElementsPosition[position]] = dataResource;
            serviceResults.push(serviceResult);
            if (position === size - 1) {
                var resError = typeof serviceResult === 'undefined' ? serviceResult : serviceResults.find((item) => {
                    return typeof item !== 'undefined' && item.result === 'error';
                });

                if (typeof resError === 'undefined' && (!this.state.hasAlignment)) {
                    this.setState({
                        data
                    }, function () {
                        this._save(item);
                        Notifications.closeModalSpinner();
                    }.bind(this));
                } else if (typeof resError !== 'undefined') {
                    this.props.callbackErrorMultimedia(dataResource.folder, resError);
                }

            } else {
                this._calladdNewOrSetResourceElement(size, position + 1, buttonSave, oldTreeStructure, item, data, id, title, serviceResults)
            }

        }.bind(this));
    }


    _save(item) {
        var data = this.state.data;
        var title = this.state.title;

        if (title.trim().length > 0 && !this.state.anomaly.hasAnomaly) {
            var returnItem = {};
            if (this.isAdd) {
                returnItem = NodeOperations.createNewItem(item, title, this.state.code, data);
            } else {
                returnItem = NodeOperations.setItem(BUtils.cloneJson(item), title, data);
            }

            this.props.callbackParent(returnItem, this.isAdd ? TreeNodeHelper.treeNodeOperations.ADD : TreeNodeHelper.treeNodeOperations.EDIT);

        } else if (title.trim().length === 0) {
            Notifications.showErrorModalMessage('TITLE_CANNOT_BE_EMPTY', 4000);
        }
    }

    _closeDocModal(showDocModal) {
        this.setState({showDocModal});
    }


    render() {

        /*console.log('**init**');
        console.log(this.state.doc.src);
        console.log('**fin**');*/

        const inputId = 'input-add-node';
        const isAdd = this.props.operation === 'add' && typeof this.props.treeObject !== 'undefined';

        var item = this.state.item;
        var headerType = '';


        if (isAdd) {
            headerType = Dict.t('ADD') + ' ' + (typeof this.props.treeObject.propLabel === 'undefined' ? Dict.t(this.props.treeObject.code) : TreeNodeHelper.getPropLabel(this.props.treeObject))
        } else {
            headerType = Dict.t(item.code);
        }

        const operation = this.props.operation;

        var anomalySpan = <span id="input-node-anomaly"
                                className={BUtils.joinClasses(stylesSCTree['input-add-node-container__anomaly'], stylesSCTree['input-add-node-container__anomaly--' + this.state.anomaly.hasAnomaly])}>
        <Glyphicon glyph={"alert"} data-tip data-for='tooltip-input-add-node-anomaly'/>
        <ReactTooltip id='tooltip-input-add-node-anomaly' type='error' className={"tree-tool-tip"}>
        <span>{Dict.t(this.state.anomaly.type)}</span>
        </ReactTooltip>
        </span>;

        var treeObjectElement = typeof this.state.data !== 'undefined' && this.state.data.length > 0 ? this._drawTreeElementObject() : '';
        const editGallery = this.state.showTreeCarousel === 'none' ? "" : this._drawEditGallery();
        const buttonBar = this._drawButtonBar();
        const strippingWordsInfos = this.state.strippingWordsInfos;

        return <div>
            {this.props.isViewer ? <div id="title-viewer"
                                        className={BUtils.joinClasses(stylesSCTree['title-viewer'], stylesSCTree['tree-minor-skin'])}>
                    <div id="title-viewer-title" className={stylesSCTree['title-viewer__title']}>{this.state.title}</div>
                    <div
                        id={TreeNodeHelper.isRootItem(item) ? "root-title-viewer-numbering" : "title-viewer-numbering"}
                        className={stylesSCTree['title-viewer__numbering']}>{this.props.numbering}</div>
                </div> :
                <>
                    <div id={'node-operations-container__header'}
                         className={stylesSCTree['node-operations-container__header']}>{'[id:' + +item.key + '] '}{headerType}</div>
                    <div id="input-add-node-container" className={stylesSCTree['input-add-node-container']}>
                        <label id="label-node" className={stylesSCTree['input-add-node-container__label']}
                               htmlFor={inputId}>
                            {Dict.t('TITLE')}
                        </label>
                        <FormControl
                            id={inputId}
                            className={stylesSCTree['input-add-node-container__input']}
                            type="text"
                            placeholder={Dict.t('TITLE')}
                            ref={(input) => {
                                this.formControl = input;
                            }}
                            value={this.state.title}
                            onChange={(evt) => this._handleTitle(evt)}
                            onKeyDown={(evt) => {
                                if (evt.keyCode === 27) {
                                    TreeDOMHelper.hideNodePageContainer();
                                } else if (evt.keyCode === 13) {
                                    this._save(item, operation);
                                }
                            }}
                        />
                        {anomalySpan}
                    </div>
                </>}
            <div id="tree-object-element-container"
                 className={stylesSCTree['tree-object-element-container--' + (this.state.isBasicItem ? 'no-overflow' : 'overflow')] + " " + (this.props.isTreeLink ? stylesSCTree['tree-object-element__treelink-container'] : '')}>{treeObjectElement}</div>
            {editGallery}
            {buttonBar}
            <TreeModalStrippingWords showDocModal={this.state.showDocModal}
                                     doc={this.state.doc}
                                     originalHtml={this.state.originalHtml}
                                     item={this.props.item}
                                     projectName={this.props.projectName}
                                     strippingWordsInfos={this.state.strippingWordsInfos}
                                     callbackParentClose={(newState) => this._closeDocModal(!newState)}
            />
        </div>
    }
}

TreeItemMenu.contextType = TreeContext;